import { SettingIcon } from "@100mslive/react-icons";
import {
    HMSNotificationTypes,
    selectHLSState,
    selectHMSMessages,
    selectIsLocalAudioEnabled,
    selectIsLocalScreenShared,
    selectIsLocalVideoEnabled,
    selectLocalPeer,
    selectPeers,
    selectPeerScreenSharing,
    selectScreenShareByPeerID,
    useDevices,
    useHMSActions,
    useHMSNotifications,
    useHMSStore
} from "@100mslive/react-sdk";
import {
    IconButton,
    StyledVideoTile,
    useBorderAudioLevel,
    useTheme,
    Video
} from "@100mslive/react-ui";
import {
    Avatar,
    Badge,
    Box,
    Button,
    Card,
    CardContent,
    Dialog,
    DialogContent,
    DialogTitle,
    Grid,
    Hidden,
    InputAdornment,
    List,
    ListItem,
    ListItemAvatar,
    ListItemSecondaryAction,
    ListItemText,
    makeStyles, Snackbar, TextField,
    Tooltip
} from "@material-ui/core";
import { Cancel, OpenInNew } from "@material-ui/icons";
import FavoriteIcon from "@material-ui/icons/Favorite";
import FileCopyIcon from "@material-ui/icons/FileCopyOutlined";
import PrintIcon from "@material-ui/icons/Print";
import SaveIcon from "@material-ui/icons/Save";
import ShareIcon from "@material-ui/icons/Share";
import { Alert } from "@material-ui/lab";
import $ from "jquery";
import moment from "moment";
import React, { useEffect, useState } from "react";
import ReactImageGallery from "react-image-gallery";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import _ from "underscore";
import ProfilePic from "../../../assets/images/custom/profilepic.svg";
import SharePop from "../../../components/common/shareLivestream";
import Timer from "../../../components/common/Timer";
import Modal from "../../../components/Modal/Modal";
import {
    socket,
    startSocketService,
    stopSocketService
} from "../../../helpers/socketHelper";
import {
    createGuid,
    dataURLtoFile,
    IsNullOrEmpty,
    letterValue,
    pad,
    sleep
} from "../../../helpers/utility";
import FileAPI from "../../../store/file/file.api";
import {
    addCartRequest,
    fetchPaymentConfigRequest,
    getCategoryRequest,
    getProductByIDSRequest
} from "../../../store/shopping/shopping.actions";
import {
    getCartList,
    getCartProductList,
    getCategoryList
} from "../../../store/shopping/shopping.selector";
import {
    createBookMarkRequest,
    fetchEventRequest,
    fetchLiveStreamByIdRequest,
    fetchLiveStreamByIdSuccess,
    fetchReactionRequest,
    updateEventInternal,
    updateLiveStreamingRequest
} from "../../../store/social/social.actions";
import SocialAPI from "../../../store/social/social.api";
import {
    getEvents,
    getFollowingStreams,
    getLiveStream,
    getRecentLiveStreams
} from "../../../store/social/social.selector";
import {
    createRoomRequest,
    createRoomSuccess,
    fetchAppTokenRequest,
    fetchAppTokenSuccess
} from "../../../store/social/streaming/streaming.actions";
import StreamingAPI from "../../../store/social/streaming/streaming.api";
import {
    GetAppToken,
    GetRoomDetails
} from "../../../store/social/streaming/streaming.selector";
import { getPrivateLoungeUserRequest } from "../../../store/user/privatelounge/privatelounge.actions";
import { getUserPrivateLounge } from "../../../store/user/privatelounge/privatelounge.selector";
import {
    fetchOtherUserProfileRequest,
    fetchUserProfileRequest,
    searchUserRequest
} from "../../../store/user/user.actions";
import { getImage, getUserProfile } from "../../../store/user/user.selector";
import { ConnectionIndicator } from "../Preview/preview/ConnectionIndicator";
import Settings from "../Preview/preview/Settings";

const responsive = {
    superLargeDesktop: {
        // the naming can be any, depends on you.
        breakpoint: { max: 4000, min: 3000 },
        items: 8,
    },
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 4,
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 4,
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 2,
    },
};

const useStyles = makeStyles((theme) => ({
    root: {
        transform: "translateZ(0px)",
        flexGrow: 1,
    },
    exampleWrapper: {
        position: "relative",
        marginTop: theme.spacing(3),
        height: 380,
    },
    radioGroup: {
        margin: theme.spacing(1, 0),
    },
    speedDial: {
        position: "absolute",
        "&.MuiSpeedDial-directionUp, &.MuiSpeedDial-directionLeft": {
            bottom: theme.spacing(2),
            right: theme.spacing(2),
        },
        "&.MuiSpeedDial-directionDown, &.MuiSpeedDial-directionRight": {
            top: theme.spacing(2),
            left: theme.spacing(2),
        },
    },
}));

const actions = [
    { icon: <FileCopyIcon />, name: "Copy" },
    { icon: <SaveIcon />, name: "Save" },
    { icon: <PrintIcon />, name: "Print" },
    { icon: <ShareIcon />, name: "Share" },
    { icon: <FavoriteIcon />, name: "Like" },
];

function Peer({
    peer,
    isZoomIn,
    onToggleFullScreen,
    isFullScreen,
    isPIP,
    isSide,
    videoEnabled,
    peersCount,
    isOwner,
    devices,
}) {
    let isMirroring = true;
    const { allDevices, selectedDeviceIDs, updateDevice } = devices;
    if (
        allDevices &&
        allDevices.videoInput &&
        allDevices.videoInput.length > 0
    ) {
        allDevices.videoInput.forEach((x) => {
            if (
                x.label.toLowerCase().indexOf("back") > -1 &&
                selectedDeviceIDs.videoInput === x.deviceId
            ) {
                isMirroring = false;
            }
        });
    }
    const history = useNavigate();
    const amIScreenSharing = useHMSStore(selectIsLocalScreenShared);
    const presenter = useHMSStore(selectPeerScreenSharing);
    const settingStyles = {
        bottom: "10px",
        right: "20px",
    };

    const borderAudioRef = useBorderAudioLevel(peer?.audioTrack);
    const screenshareVideoTrack = useHMSStore(
        selectScreenShareByPeerID(presenter?.id)
    );
    const {
        aspectRatio: { width, height },
    } = useTheme();
    const isSmall =
        !isZoomIn ||
        peer.roleName === "audience" ||
        (peer.isLocal && !videoEnabled) ||
        (peer.isLocal && presenter?.id === peer.id);

    if (isSmall) {
        if ((!videoEnabled && isZoomIn) || (amIScreenSharing && isZoomIn)) {
            return (
                <StyledVideoTile.Container
                    css={{
                        aspectRatio: "auto",
                        width: "100%",
                        height: isSide
                            ? isFullScreen
                                ? "min(30vw, 25vh)"
                                : "min(160px, 25vh)"
                            : isPIP
                                ? "min(35vh, 80vw)"
                                : isFullScreen
                                    ? "min(55vw, calc(100vh - 80px))"
                                    : "min(55vw, calc(100vh - 160px))",
                        "@sm": {
                            width: "100%",
                            height: isSide
                                ? "min(150px, 25vh)"
                                : "min(41vh, 76vh)",
                            maxWidth: "98%",
                        },
                    }}
                    ref={borderAudioRef}
                >
                    <Box
                        display="flex"
                        className="mx-3"
                        flexDirection="column"
                        width="100%"
                        justifyContent="center"
                        alignItems="center"
                    >
                        <Avatar
                            style={{
                                width: isSide
                                    ? isPIP
                                        ? 80
                                        : 130
                                    : isPIP
                                        ? 130
                                        : 250,
                                height: isSide
                                    ? isPIP
                                        ? 80
                                        : 130
                                    : isPIP
                                        ? 130
                                        : 250,
                            }}
                            className="mx-4"
                            src={JSON.parse(peer.metadata).image}
                            alt={peer.name}
                        />
                        {!isSide && (
                            <h4 className="text-center">{peer.name}</h4>
                        )}
                        {amIScreenSharing && isPIP && (
                            <div className="center-div video-top">
                                <span className="bg-greying">
                                    <i className="fa fa-eye "></i>&nbsp;
                                    {peersCount}
                                </span>
                                <span
                                    className="ml-3 px-2"
                                    style={{ background: "red" }}
                                >
                                    LIVE
                                </span>
                                {isPIP && (
                                    <OpenInNew
                                        id="pop-big"
                                        className="ml-2 bg-greying"
                                        onClick={() => {
                                            history("/page/livestream");
                                        }}
                                    />
                                )}
                            </div>
                        )}
                    </Box>
                </StyledVideoTile.Container>
            );
        } else {
            return (
                <Box
                    display="flex"
                    className="mx-3"
                    flexDirection="column"
                    width="100%"
                    justifyContent="center"
                    alignItems="center"
                >
                    <Avatar
                        style={{
                            width: isSide
                                ? isPIP
                                    ? 80
                                    : 130
                                : isPIP
                                    ? 160
                                    : 320,
                            height: isSide
                                ? isPIP
                                    ? 80
                                    : 130
                                : isPIP
                                    ? 130
                                    : 160,
                        }}
                        className="mx-4"
                        src={JSON.parse(peer.metadata).image}
                        alt={peer.name}
                    />
                    <span className="text-center text-md">{peer.name}</span>
                </Box>
            );
        }
    }

    return (
        <StyledVideoTile.Container
            css={{
                aspectRatio: "auto",
                width: "100%",
                height: isSide
                    ? isFullScreen
                        ? "min(30vw, 25vh)"
                        : "min(160px, 25vh)"
                    : isPIP
                        ? "min(35vh, 80vw)"
                        : isFullScreen
                            ? "min(55vw, calc(100vh - 80px))"
                            : "min(55vw, calc(100vh - 160px))",
                "@sm": {
                    width: "100%",
                    height: isSide ? "min(150px, 25vh)" : "min(41vh, 76vh)",
                    maxWidth: "98%",
                },
            }}
            ref={borderAudioRef}
        >
            {peer.isLocal && !isSide ? (
                <ConnectionIndicator isTile peerId={peer.id} />
            ) : (
                <></>
            )}
            {!isSide && (
                <div className="center-div video-top">
                    <span className="bg-greying">
                        <i className="fa fa-eye"></i>&nbsp;{peersCount}
                    </span>
                    <span className="ml-3 px-2" style={{ background: "red" }}>
                        LIVE
                    </span>
                    {isPIP && (
                        <OpenInNew
                            id="pop-big"
                            className="ml-2 bg-greying"
                            onClick={() => {
                                history("/page/livestream");
                            }}
                        />
                    )}
                </div>
            )}
            <Video
                id={peer.isLocal && !isSide && isOwner ? "tab-video" : ""}
                onDoubleClick={() => {
                    if (isPIP) {
                        history("/page/livestream");
                    } else {
                        onToggleFullScreen();
                    }
                }}
                mirror={
                    presenter?.id === peer.id || !isMirroring ? false : true
                }
                trackId={
                    presenter?.id === peer.id
                        ? screenshareVideoTrack.id
                        : peer.videoTrack
                }
                data-testid="preview_tile"
                style={{
                    visibility:
                        presenter?.id === peer.id && peer.isLocal
                            ? "hidden"
                            : "visible",
                    objectFit:
                        screenshareVideoTrack && screenshareVideoTrack.id
                            ? "contain"
                            : "cover",
                }}
            />
            {peer.isLocal && !isSide && !isPIP ? (
                <Settings>
                    <StyledVideoTile.AttributeBox css={settingStyles}>
                        <IconButton data-testid="preview_setting_btn">
                            <SettingIcon />
                        </IconButton>
                    </StyledVideoTile.AttributeBox>
                </Settings>
            ) : (
                <></>
            )}
            <Snackbar
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "center",
                }}
                open={amIScreenSharing}
            >
                <Alert severity="warning">You are screen sharing</Alert>
            </Snackbar>
        </StyledVideoTile.Container>
    );
}

export default function LivestreamChild(props) {
    const { isPIP } = props;
    const classes = useStyles();
    const dispatch = useDispatch();
    const history = useNavigate();
    const hmsActions = useHMSActions();
    const notification = useHMSNotifications();
    const presenter = useHMSStore(selectPeerScreenSharing);
    const amIScreenSharing = useHMSStore(selectIsLocalScreenShared);
    const audioEnabled = useHMSStore(selectIsLocalAudioEnabled);
    const videoEnabled = useHMSStore(selectIsLocalVideoEnabled);
    const devices = useDevices();
    const [selectedUser, setSelectedUser] = useState("");
    const peers = useHMSStore(selectPeers);
    const localPeer = useHMSStore(selectLocalPeer);
    const [isConnected, setConnection] = useState(false);
    const [isEnd, setEnd] = useState(false);
    const [show, setShow] = useState(false);
    const [showShared, setShared] = useState(false);
    const [selectedMenu, setSelectedMenu] = useState("Chat");
    const [isRequestToJoin, setRequestToJoin] = useState(false);
    const [isFullScreen, setFullScreen] = useState(false);
    const [closingMsg, setClosingMsg] = useState("");
    const [disableControl, setDisableControl] = useState(false);
    const [value, setValue] = React.useState(-1);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [isNewMessage, setNewMessage] = useState(false);
    const [apiCalled, setAPICalled] = useState(false);
    const allMessages = useHMSStore(selectHMSMessages);
    const hlsState = useHMSStore(selectHLSState)

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const tagColors = [
        "btn-danger",
        "btn-success",
        "btn-warning",
        "btn-primary",
        "btn-warning",
        "btn-info",
    ];

    const {
        livestream,
        userPrivateLounge,
        recentLiveStreams,
        justLiveStreams,
        token,
        roomDetail,
        cartProducts,
        categories,
        cart,
        userProfile,
        comments,
    } = useSelector((state) => {
        return {
            livestream: getLiveStream(state),
            cartProducts: getCartProductList(state),
            cart: getCartList(state),
            userProfile: getUserProfile(state),
            comments: getEvents(state),
            categories: getCategoryList(state),
            token: GetAppToken(state),
            roomDetail: GetRoomDetails(state),
            userPrivateLounge: getUserPrivateLounge(state),
            recentLiveStreams: getRecentLiveStreams(state),
            justLiveStreams: getFollowingStreams(state),
        };
    });

    function capture() {
        if (livestream.owner._id === userProfile._id) {
            try {
                var canvas = document.getElementById("canvas");
                var video = document.getElementById("tab-video");
                canvas.width = 280;
                canvas.height = 350;
                canvas.getContext("2d").drawImage(video, 0, 0, 280, 350);
                var files = dataURLtoFile(
                    canvas.toDataURL(),
                    livestream._id + ".png"
                );
                FileAPI.UploadLives(files).then((x) => {
                    SocialAPI.UpdateScreenShot(
                        livestream._id,
                        getImage(x.body.data)
                    );
                });
            } catch (ex) {
                console.log(ex);
            }
        }
        /** End **/
    }

    // useEffect(() => {

    //     dispatch(fetchEventRequest("?where=livestream:" + livestream._id));
    // }, [allMessages]);

    useEffect(() => {
        if (!notification) {
            return;
        }

        console.log("notification type", notification.type);
        console.log("data", notification.data);

        // you can use the following to show appropriate toast notifications for eg.
        switch (notification.type) {
            case HMSNotificationTypes.PEER_JOINED:
                if (!IsNullOrEmpty(notification.data.name) && notification.data.name !== "Beam") {
                    let dat = {
                        infoUser: {
                            fullName: notification.data.name,
                        },
                        dateCreated: new Date(),
                    };
                    dat.commentType = "joined";
                    // hmsActions.sendBroadcastMessage("joined@@@@");
                    dispatch(updateEventInternal(dat));
                    // console.log(`${notification.data.name} joined`);
                }
                break;
            case HMSNotificationTypes.PEER_LEFT:
                if (!IsNullOrEmpty(notification.data.name) && notification.data.name !== "Beam") {
                    if (notification.data.customerUserId == selectedUser) {
                        setSelectedUser(userProfile._id);
                    }
                    // hmsActions.sendBroadcastMessage("left####");
                    let req = {
                        infoUser: {
                            fullName: notification.data.name,
                        },
                        dateCreated: new Date(),
                    };
                    req.commentType = "left";
                    dispatch(updateEventInternal(req));
                }
                console.log(`${notification.data.name} left`);
                break;
            case HMSNotificationTypes.NEW_MESSAGE:
                const sender = _.find(peers, x => x.id === notification.data.sender);
                if (sender) {
                    let newMetadata = JSON.parse(sender.metadata);
                    if (newMetadata.isGuest) {
                        let req = {
                            "type": "comment",
                            "timesAppear": 62989,
                            "status": "Active",
                            "_id": notification.data.id,
                            "user": sender.id,
                            "livestream": notification.data.sender,
                            "content": notification.data.message,
                            "code": notification.data.id,
                            "dateCreated": notification.data.time,
                            "dateUpdated": notification.data.time,
                            "infoUser": {
                                "_id": sender.id,
                                "fullName": sender.name,
                                "code": notification.data.id
                            }
                        };

                        dispatch(updateEventInternal(req));
                    }
                    else {
                        dispatch(
                            fetchEventRequest("?where=livestream:" + livestream._id)
                        );
                    }
                }
                console.log(
                    `${notification.data.message} received from ${notification.data.senderName}`
                );
                break;
            case HMSNotificationTypes.ERROR:
                if (notification.data.description === "room is not active") {
                    dispatch(fetchLiveStreamByIdSuccess({ data: {} }));
                    dispatch(createRoomSuccess({}));
                    dispatch(fetchAppTokenSuccess(""));
                    history("/");
                }
                if (notification &&
                    notification.data &&
                    notification.data.code &&
                    notification.data.code.toString() == "3008") {
                    Swal.fire({
                        title: "Enable Audio?",
                        html: `Your device's audio setting is currently disabled; pressing Enable will restore it`,
                        icon: "warning",
                        customClass: {
                            icon: "disp-none",
                            confirmButton: "btn btn-success order-2",
                            cancelButton: "btn btn-danger order-1 right-gap",
                            denyButton: "order-3",
                        },
                        showCancelButton: false,
                        confirmButtonText: "Enable",
                    }).then((x) => {
                        if (x.isConfirmed) {
                            hmsActions.unblockAudio()
                        }
                    })
                }
                console.log("[Error]", notification.data);
                console.log("[Error Code]", notification.data.code);
                break;
            case HMSNotificationTypes.RECONNECTING:
                console.log("[Reconnecting]", notification.data);
                break;
            case HMSNotificationTypes.RECONNECTED:
                console.log("[Reconnected]");
                break;
            case HMSNotificationTypes.METADATA_UPDATED:
                break;
            case HMSNotificationTypes.NAME_UPDATED:
                break;
            case HMSNotificationTypes.ROLE_UPDATED:
                if (notification.data.customerUserId === userProfile._id) {
                    if (localPeer.roleName === "guest") {
                        hmsActions.setLocalVideoEnabled(true);
                        hmsActions.setLocalAudioEnabled(true);
                    } else if (localPeer.roleName === "audience") {
                        hmsActions.setLocalVideoEnabled(false);
                        hmsActions.setLocalAudioEnabled(false);
                    }
                    let isPeerExist = peers.filter(
                        (z) => z.customerUserId === userProfile._id
                    );
                    if (isPeerExist.length > 0) {
                        let newMetadata = JSON.parse(isPeerExist[0].metadata);
                        newMetadata.isRequested = false;
                        hmsActions.changeMetadata(newMetadata);
                    }
                }

                console.log(
                    `peer updated(${notification.type}), new peer=`,
                    notification.data
                );
                break;
            case HMSNotificationTypes.TRACK_DEGRADED:
                console.log(
                    `track - ${notification.data} degraded due to poor network`
                );
                break;
            case HMSNotificationTypes.TRACK_RESTORED:
                console.log(`track - ${notification.data} recovered`);
                break;
            case HMSNotificationTypes.ROOM_ENDED:
                if (livestream.owner._id !== userProfile._id && isPIP) {
                    handleEnd(true);
                    setEnd(true);
                    hmsActions.leave();
                    Swal.fire({
                        title: "Live end",
                        html: `<p class="text-grey">Thank you for joining!</p><br/><p class="text-grey">Get the latest notification from <a class="link-username">@${livestream.owner.userName}</a> and continue conversation in the chatroom</p>`,
                        icon: "success",
                        customClass: {
                            icon: "disp-none",
                            confirmButton: "btn btn-success order-2",
                            cancelButton: "btn btn-danger order-1 right-gap",
                            denyButton: "order-3",
                        },
                        showCancelButton: true,
                        cancelButtonText: livestream.isSubscribe
                            ? "Close"
                            : `Subscribe ${userPrivateLounge.currencySubscription} ${userPrivateLounge.monthlySubscription} / month`,
                        confirmButtonText: "Join chat room",
                    }).then((result) => {
                        if (result.isConfirmed) {
                            dispatch(fetchLiveStreamByIdSuccess({ data: {} }));
                            dispatch(createRoomSuccess({}));
                            dispatch(fetchAppTokenSuccess(""));
                            history("/page/chat", {
                                state: {
                                    userId: livestream.owner._id,
                                },
                            });
                        } else {
                            if (livestream.isSubscribe) {
                                dispatch(
                                    fetchLiveStreamByIdSuccess({ data: {} })
                                );
                                dispatch(createRoomSuccess({}));
                                dispatch(fetchAppTokenSuccess(""));
                                history("/");
                            } else {
                                dispatch(fetchPaymentConfigRequest());
                                dispatch(
                                    fetchLiveStreamByIdSuccess({ data: {} })
                                );
                                dispatch(createRoomSuccess({}));
                                dispatch(fetchAppTokenSuccess(""));
                                history("/page/subscription_payment");
                            }
                        }
                    });
                }
                console.log(`room ended, reason - ${notification.data.reason}`);
                break;
            case HMSNotificationTypes.REMOVED_FROM_ROOM:
                console.log(
                    `removed from room, reason - ${notification.data.reason}`
                );
                break;
            case HMSNotificationTypes.DEVICE_CHANGE_UPDATE:
                console.log(`device changed - ${notification.data}`);
                break;
            default:
                break;
        }
    }, [notification]);

    useEffect(() => {
        setSelectedUser(userProfile._id);
    }, [userProfile, livestream]);

    useEffect(() => {
        let isPeerExist = peers.filter(
            (z) => z.customerUserId === userProfile._id
        );
        if (isPeerExist.length > 0) {
            if (isPeerExist[0].roleName === "audience") {
                setSelectedUser(livestream.owner._id);
            }
            let metadata = {};
            if (
                isPeerExist[0].metadata &&
                !IsNullOrEmpty(isPeerExist[0].metadata)
            ) {
                metadata = JSON.parse(isPeerExist[0].metadata);
                setRequestToJoin(metadata.isRequested);
            }
        }
    }, [peers]);

    useEffect(() => {
        if (roomDetail.id && livestream._id) {
            dispatch(
                fetchAppTokenRequest({
                    room_id: roomDetail.id,
                    user_id: userProfile._id,
                    role:
                        livestream.guestInvited.indexOf(userProfile._id) > -1
                            ? "guest"
                            : livestream.owner._id === userProfile._id
                                ? "host"
                                : "audience",
                })
            );
        }
    }, [roomDetail, livestream]);

    useEffect(() => {
        if (!IsNullOrEmpty(token)) {
        }
    }, [token]);

    useEffect(() => {
        if (livestream.streamingStatus !== "Streaming" && livestream._id) {
            if (
                userProfile._id === livestream.owner._id &&
                !IsNullOrEmpty(token)
            ) {
                handleJoin();
            } else {
                history("/page/preview");
            }
        } else {
            if (!IsNullOrEmpty(token)) {
                let selectedCategory = _.find(
                    categories,
                    (x) => x._id === livestream.category
                );
                let invitedGuests = livestream.guestInfo.map((x) => x._id);
                let emailGuests = livestream.guestInvited.map((x) => x.email);
                if (userProfile._id === livestream.owner._id) {
                    handleJoin();
                } else if (selectedCategory) {
                    switch (selectedCategory.name) {
                        case "Public Hall":
                            handleJoin();
                            break;
                        case "Private Hall":
                            if (livestream.isSubscribe) {
                                handleJoin();
                            } else {
                                showUnAuthorized();
                            }
                            break;
                        case "Meeting Room":
                            if (
                                invitedGuests.indexOf(userProfile._id) > -1 ||
                                emailGuests.indexOf(userProfile.email) > -1
                            ) {
                                handleJoin();
                            } else {
                                showUnAuthorized();
                            }
                            break;
                        case "VIP Circle":
                            let isInVIP =
                                livestream.vipCircleDetail &&
                                livestream.vipCircleDetail.vipCircle &&
                                livestream.vipCircleDetail.vipCircle.guests.filter(
                                    (x) =>
                                        x.status === "Subscribed" &&
                                        x.userId === userProfile._id
                                );
                            if (isInVIP && isInVIP.length > 0) {
                                handleJoin();
                            } else {
                                showUnAuthorized();
                            }
                            break;
                    }
                }
            }
        }
    }, [categories, token]);

    function showUnAuthorized() {
        Swal.fire({
            title: "Invited only",
            text: "You do not have access to this live.",
            icon: "error",
            showCancelButton: false,
            confirmButtonColor: "red",
            confirmButtonText: "Close",
            customClass: {
                cancelButton: "order-1 right-gap",
                confirmButton: "order-2",
                denyButton: "order-3",
            },
        }).then((result) => {
            if (result.isConfirmed) {
                history("/");
            }
        });
    }

    useEffect(() => {
        if (isPIP) {
            stopSocketService();
        }
    }, [isPIP]);

    useEffect(() => {
        if (presenter && presenter.id && !amIScreenSharing) {
            setFullScreen(true);
        } else {
            setFullScreen(false);
        }
    }, [presenter]);

    useEffect(() => {
        if (isFullScreen) {
            if (
                document.fullscreenElement ||
                document.webkitFullscreenElement ||
                document.mozFullScreenElement ||
                document.msFullscreenElement
            ) {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.webkitExitFullscreen) {
                    document.webkitExitFullscreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            } else {
                let element = $("#fullScreening").get(0);
                if (element.requestFullscreen) {
                    element.requestFullscreen();
                } else if (element.mozRequestFullScreen) {
                    element.mozRequestFullScreen();
                } else if (element.webkitRequestFullscreen) {
                    element.webkitRequestFullscreen(
                        Element.ALLOW_KEYBOARD_INPUT
                    );
                } else if (element.msRequestFullscreen) {
                    element.msRequestFullscreen();
                }
            }
        }
    }, [isFullScreen]);

    useEffect(() => {
        SocialAPI.GetLiveStreamById(livestream._id).then((x) => {
            dispatch(fetchLiveStreamByIdSuccess({ data: x.data }));
        });
        navigator.permissions.query({ name: "camera" }).then(function (result) {
            if (result.state === "granted") {
                //permission has already been granted, no prompt is shown
            } else if (result.state === "prompt") {
                //there's no peristent permission registered, will be showing the prompt
            } else if (result.state === "denied") {
                Swal.fire({
                    title: "Permission Required",
                    text: "You dont have permission to access camera and microphone from this device.",
                    icon: "error",
                    showCancelButton: false,
                    confirmButtonColor: "red",
                    confirmButtonText: "Close",
                    customClass: {
                        cancelButton: "order-1 right-gap",
                        confirmButton: "order-2",
                        denyButton: "order-3",
                    },
                });
            }
        });
        startSocketService();
        dispatch(searchUserRequest());
        dispatch(updateLiveStreamingRequest(true));
        dispatch(fetchReactionRequest());
        dispatch(getCategoryRequest());
        dispatch(fetchEventRequest("?where=livestream:" + livestream._id));

        socket.on("endLiveWozaMessage", (data) => {
            let req = data;

            req.content = data.message;
            req.commentType = "end";
            req.dateCreated = moment().format();
            req.dateUpdated = moment().format();
            dispatch(updateEventInternal(req));
            handleEnd(true);

            if (livestream.owner._id !== userProfile._id) {
                setEnd(true);
                hmsActions.leave();
                Swal.fire({
                    title: "Live end",
                    html: `<p class="text-grey">Thank you for joining!</p><br/><p class="text-grey">Get the latest notification from <a class="link-username">@${livestream.owner.userName}</a> and continue conversation in the chatroom</p>`,
                    icon: "success",
                    customClass: {
                        icon: "disp-none",
                        confirmButton: "btn btn-success order-2",
                        cancelButton: "btn btn-danger order-1 right-gap",
                        denyButton: "order-3",
                    },
                    showCancelButton: true,
                    cancelButtonText: livestream.isSubscribe
                        ? "Close"
                        : `Subscribe ${userPrivateLounge.currencySubscription} ${userPrivateLounge.monthlySubscription} / month`,
                    confirmButtonText: "Join chat room",
                }).then((result) => {
                    if (result.isConfirmed) {
                        dispatch(fetchLiveStreamByIdSuccess({ data: {} }));
                        dispatch(createRoomSuccess({}));
                        dispatch(fetchAppTokenSuccess(""));
                        history("/page/chat", {
                            state: {
                                userId: livestream.owner._id,
                            },
                        });
                    } else {
                        if (livestream.isSubscribe) {
                            dispatch(fetchLiveStreamByIdSuccess({ data: {} }));
                            dispatch(createRoomSuccess({}));
                            dispatch(fetchAppTokenSuccess(""));
                            history("/");
                        } else {
                            dispatch(fetchPaymentConfigRequest());
                            dispatch(fetchLiveStreamByIdSuccess({ data: {} }));
                            dispatch(createRoomSuccess({}));
                            dispatch(fetchAppTokenSuccess(""));
                            history("/page/subscription_payment");
                        }
                    }
                });
            }
        });

        socket.on("leftLiveMessage", (data) => {
            console.log("left live Message");
        });

        socket.on("joinLiveMessage", (data) => {
            let updateLiveStream = livestream;
            let isExist =
                livestream.guestStats.filter((x) => x.id === data.infoUser._id)
                    .length > 0;
            if (!isExist) {
                let guest = {
                    fullName: data.infoUser.fullName,
                    id: data.infoUser._id,
                    image: getImage(data.infoUser.avatar.attachments),
                    role:
                        livestream.owner._id === data.infoUser._id
                            ? "host"
                            : "audience",
                    status:
                        livestream.owner._id === data.infoUser._id
                            ? "joined"
                            : livestream.guestInvited.indexOf(
                                data.infoUser._id
                            ) > -1
                                ? "joined"
                                : "listening",
                    uid: letterValue(data.infoUser._id),
                    _id: createGuid(),
                };
                updateLiveStream.guestStats(guest);
                dispatch(
                    fetchLiveStreamByIdSuccess({
                        data: updateLiveStream,
                    })
                );
            }
            console.log("joined live Message");
        });

        // socket.on("sendCommentMessage", (data) => {
        //   let req = data.data;
        //   req.infoUser = data.infoUser;
        //   req.dateCreated = moment().format();
        //   req.dateUpdated = moment().format();
        //   dispatch(updateEventInternal(req));
        //   if (userProfile._id !== data.infoUser._id) {
        //     setNewMessage(true);
        //   }
        // });

        setTimeout(() => {
            capture();
        }, 10000);

        if (document.addEventListener) {
            document.addEventListener("fullscreenchange", exitHandler, false);
            document.addEventListener(
                "mozfullscreenchange",
                exitHandler,
                false
            );
            document.addEventListener("MSFullscreenChange", exitHandler, false);
            document.addEventListener(
                "webkitfullscreenchange",
                exitHandler,
                false
            );
        }

        function exitHandler() {
            if (
                !document.webkitIsFullScreen &&
                !document.mozFullScreen &&
                !document.msFullscreenElement
            ) {
                setFullScreen(false);
            }
        }

        return () => {
            if (document.removeEventListener) {
                document.removeEventListener("fullscreenchange", exitHandler);
                document.removeEventListener(
                    "mozfullscreenchange",
                    exitHandler
                );
                document.removeEventListener("MSFullscreenChange", exitHandler);
                document.removeEventListener(
                    "webkitfullscreenchange",
                    exitHandler
                );
            }
        };
    }, []);

    useEffect(() => {
        if (!localPeer && !isEnd) {
            dispatch(
                createRoomRequest({
                    name: livestream._id,
                    description: livestream.contents,
                })
            );
        }
    }, [localPeer]);

    useEffect(() => {
        if (livestream._id) {
            dispatch(
                getProductByIDSRequest({
                    products: livestream.products.map((x) => x.id),
                })
            );

            dispatch(
                getPrivateLoungeUserRequest({
                    userId: livestream.owner._id,
                })
            );

            let curUser =
                livestream.guestInvited.indexOf(userProfile._id) > -1
                    ? "guests"
                    : livestream.owner._id === userProfile._id
                        ? "host"
                        : "audience";
            let isExistInLast = livestream.guestStats.filter(
                (x) => x.id === userProfile._id
            );
            if (isExistInLast.length > 0) {
                curUser =
                    isExistInLast[0].status === "listening" ||
                        isExistInLast[0].status === "requested"
                        ? "audience"
                        : "guests";
            }
            if (livestream.owner._id === userProfile._id) {
                curUser = "host";
            }
        }
    }, [livestream]);

    useEffect(() => {
        if (userProfile._id && livestream._id && !isConnected) {
            setConnection(true);
            let actingGuest = "listening";
            let isExistInLast = livestream.guestStats.filter(
                (x) => x.id === userProfile._id
            );
            if (isExistInLast.length > 0) {
                actingGuest = isExistInLast[0].status;
            }
        }
    }, [livestream, userProfile]);

    let duration = [0, 0, 0];
    let timeStart = livestream.timeStart;
    if (!livestream.timeStart) {
        timeStart = moment.utc().add(livestream.limitTimes, "hours").format();
    } else {
        timeStart = moment
            .utc(timeStart)
            .add(livestream.limitTimes, "hours")
            .format();
    }

    if (livestream._id) {
        if (livestream.owner._id === userProfile._id) {
            let ms = moment.utc(timeStart).diff(moment.utc());
            var d = moment.duration(ms);
            duration = [d._data.hours, d._data.minutes, d._data.seconds];
        } else {
            let ms = moment
                .utc()
                .add(livestream.limitTimes, "hours")
                .diff(moment.utc(timeStart));
            var d = moment.duration(ms);
            duration = [d._data.hours, d._data.minutes, d._data.seconds];
        }
    }

    const handleJoin = () => {
        if (socket && token && !apiCalled) {
            setAPICalled(true);
            if (livestream.owner._id === userProfile._id) {
                hmsActions.startHLSStreaming();
                StreamingAPI.startRecording(roomDetail.id);
            }
            StreamingAPI.getLastSessions(roomDetail.id).then((x) => {
                let canShow = false;
                let sessionCnt = 0;
                if (!x.data) {
                    canShow = true;
                } else {
                    x.data.forEach((y) => {
                        Object.keys(y.peers).forEach((yt) => {
                            if (y.peers[yt].user === userProfile._id) {
                                if (!y.peers[yt].left_at) {
                                    sessionCnt++;
                                }
                            }
                        });
                    });
                    if (sessionCnt === 0) {
                        canShow = true;
                    } else {
                        setTimeout(() => {
                            if (!localPeer || !localPeer.id) {
                                Swal.fire({
                                    title: "Action prohibited",
                                    text: "Your session is already active for this livestream.",
                                    icon: "warning",
                                    showCancelButton: true,
                                    showConfirmButton: false,
                                    cancelButtonText: "Close",
                                    customClass: {
                                        cancelButton: "order-1 right-gap",
                                        confirmButton: "order-2",
                                        denyButton: "order-3",
                                    },
                                }).then((x) => {
                                    if (x.isDismissed) {
                                        dispatch(
                                            fetchLiveStreamByIdSuccess({
                                                data: {},
                                            })
                                        );
                                        dispatch(createRoomSuccess({}));
                                        dispatch(fetchAppTokenSuccess(""));
                                        setTimeout(() => {
                                            history("/");
                                        }, 1500);
                                    }
                                });
                            }
                        }, 5000);
                    }
                    // else {
                    //   Swal.fire({
                    //     title: 'Unable to join',
                    //     text: "Your session is already active for this livestreaming",
                    //     icon: 'warning',
                    //     showCancelButton: true,
                    //     showConfirmButton: false,
                    //     cancelButtonText: "Exit",
                    //     customClass: {
                    //       cancelButton: 'order-1 right-gap',
                    //       confirmButton: 'order-2',
                    //       denyButton: 'order-3',
                    //     }
                    //   }).then((x) => {
                    //     if (x.isDismissed) {
                    //       history("/");
                    //     }
                    //   });
                    // }
                }

                if (canShow) {
                    const config = {
                        userName: userProfile.fullName,
                        authToken: token, // client-side token generated from your token service
                        settings: {
                            isAudioMuted: false,
                            isVideoMuted: false,
                        },
                        metaData: JSON.stringify({
                            id: userProfile._id,
                            image: getImage(userProfile.avatar.attachments),
                        }),
                        rememberDeviceSelection: true, // remember manual device change
                    };

                    hmsActions.join(config);
                }
                let actingGuest = true;
                let isExistInLast =
                    livestream.guestStats &&
                    livestream.guestStats.filter(
                        (x) => x.id === userProfile._id
                    );
                if (isExistInLast && isExistInLast.length > 0) {
                    actingGuest = isExistInLast[0].status === "joined";
                }
                if (livestream.guestInvited) {
                    socket.emit("joinLive", {
                        room: livestream._id,
                        type:
                            livestream.guestInvited.indexOf(userProfile._id) >
                                -1
                                ? "guests"
                                : livestream.owner._id === userProfile._id
                                    ? "host"
                                    : "audience",
                        infoUser: userProfile,
                    });
                }
            });
        }
    };

    const handleEndAudience = (disable) => {
        if (socket) {
            setDisableControl(true);
            socket.emit("leftLive", {
                room: livestream._id,
                type: "viewers",
                infoUser: userProfile,
            });
            hmsActions.leave();
            dispatch(fetchLiveStreamByIdSuccess({ data: {} }));
            dispatch(createRoomSuccess({}));
            dispatch(fetchAppTokenSuccess(""));
            let streams = _.uniq(
                recentLiveStreams.concat(justLiveStreams),
                "_id"
            );
            let publicHall = _.find(
                categories,
                (x) => x.name === "Public Hall"
            );
            if (publicHall) {
                streams = streams.filter(
                    (x) =>
                        x.title !== "Dummy" &&
                        x.category === publicHall._id &&
                        x.streaminStatus === "Streaming"
                );
                if (streams.length > 0) {
                    let index = streams.findIndex(
                        (x) => x._id === livestream._id
                    );
                    if (index < streams.length - 2 && disable) {
                        dispatch(
                            fetchLiveStreamByIdRequest({
                                id: streams[index + 1]._id,
                                history: history,
                            })
                        );
                        dispatch(
                            fetchEventRequest(
                                "?where=livestream:" + streams[index + 1]._id
                            )
                        );
                    } else if (index > 0 && !disable) {
                        dispatch(
                            fetchLiveStreamByIdRequest({
                                id: streams[index - 1]._id,
                                history: history,
                            })
                        );
                        dispatch(
                            fetchEventRequest(
                                "?where=livestream:" + streams[index - 1]._id
                            )
                        );
                    } else {
                        dispatch(
                            fetchLiveStreamByIdRequest({
                                id: streams[0]._id,
                                history: history,
                            })
                        );
                        dispatch(
                            fetchEventRequest(
                                "?where=livestream:" + streams[0]._id
                            )
                        );
                    }
                } else {
                    history("/");
                }
            }
        }
    };

    const handleEnd = (disable) => {
        if (socket) {
            setDisableControl(true);
            if (livestream.owner._id === userProfile._id) {
                hmsActions.stopHLSStreaming();
                peers.forEach((x) => {
                    if (!x.isLocal) {
                        hmsActions.changeRole(x.id, "audience", true);
                    }
                });
                setEnd(true);
                socket.emit("endLive", {
                    room: livestream._id,
                    type: "host",
                    infoUser: userProfile,
                });

                if (!disable) {
                    hmsActions.endRoom(true, "Livestream over");
                    hmsActions.leave();
                    dispatch(fetchLiveStreamByIdSuccess({ data: {} }));
                    dispatch(createRoomSuccess({}));
                    dispatch(fetchAppTokenSuccess(""));
                    sleep(1000);
                    history("/");
                } else {
                    dispatch(fetchLiveStreamByIdSuccess({ data: {} }));
                    dispatch(createRoomSuccess({}));
                    dispatch(fetchAppTokenSuccess(""));
                    sleep(1000);
                    history("/");
                }
            } else {
                let actingGuest = true;
                let isExistInLast = livestream.guestStats.filter(
                    (x) => x.id === userProfile._id
                );
                if (isExistInLast.length > 0) {
                    actingGuest = isExistInLast[0].status === "joined";
                }

                socket.emit("leftLive", {
                    room: livestream._id,
                    type:
                        livestream.guestInvited.indexOf(userProfile._id) > -1 &&
                            actingGuest
                            ? "guests"
                            : livestream.owner._id === userProfile._id
                                ? "host"
                                : "viewers",
                    infoUser: userProfile,
                });
                if (!disable) {
                    hmsActions.leave();
                    dispatch(fetchLiveStreamByIdSuccess({ data: {} }));
                    dispatch(createRoomSuccess({}));
                    dispatch(fetchAppTokenSuccess(""));
                    history("/");
                }
            }
        }
    };

    const sendComment = () => {
        let comment = document.getElementById("sendComment").value;
        if (socket && !IsNullOrEmpty(comment)) {
            socket.emit("sendComment", {
                room: livestream._id,
                dataCreate: {
                    user: userProfile.fullName,
                    timesAppear: 1,
                    livestream: livestream._id,
                    type: "Main",
                    content: comment,
                },
                infoUser: userProfile,
            });
            document.getElementById("sendComment").value = "";
            hmsActions.sendBroadcastMessage(comment);
        }
    };

    const requestToJoin = (uid, status) => {
        handleRequest(uid, status);
    };

    const handleRequest = (uid, status) => {
        let actingGuest = true;
        let isExistInLast = livestream.guestStats.filter(
            (x) => x.id === userProfile._id
        );
        if (isExistInLast.length > 0) {
            actingGuest = isExistInLast[0].status === "joined";
        }
        socket.emit("requestToJoin", {
            room: livestream._id,
            infoUser: userProfile,
            uid: uid,
            status: status ? status : "requested",
            role:
                livestream.guestInvited.indexOf(userProfile._id) > -1 &&
                    actingGuest
                    ? "guest"
                    : livestream.owner._id === userProfile._id
                        ? "host"
                        : "audience",
        });
    };

    const handleAddUser = async (x) => {
        if (livestream.owner._id === userProfile._id) {
            Swal.fire({
                title: "Add co-host?",
                text: "Once approved, the co-host will join your livestream",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Confirm",
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                showConfirmButton: true,
                cancelButtonText: "Cancel",
                customClass: {
                    cancelButton: "order-1 right-gap",
                    confirmButton: "order-2",
                    denyButton: "order-3",
                },
            }).then(async (result) => {
                if (result.isConfirmed) {
                    hmsActions.changeRole(x.id, "guest", true);
                    socket.emit("requestToJoin", {
                        room: livestream._id,
                        infoUser: {
                            ...userProfile,
                            _id: x.id,
                            fullName: x.fullName,
                            image: x.image,
                        },
                        uid: x.uid,
                        status: "joined",
                        role: "guest",
                    });
                }
            });
        }
    };

    const handleRemoveUser = (x) => {
        if (livestream.owner._id === userProfile._id) {
            Swal.fire({
                title: "Remove the co-host?",
                text: "You can invite them to the livestream again.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Remove",
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                showConfirmButton: true,
                cancelButtonText: "Cancel",
                customClass: {
                    cancelButton: "order-1 right-gap",
                    confirmButton: "order-2",
                    denyButton: "order-3",
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    hmsActions.changeRole(x.id, "audience", true);
                    socket.emit("requestToJoin", {
                        room: livestream._id,
                        infoUser: {
                            ...userProfile,
                            _id: x.id,
                            fullName: x.fullName,
                            image: x.image,
                        },
                        uid: x.uid,
                        status: "listening",
                        role: "audience",
                    });
                }
            });
        }
    };

    function getReactionIcon(reaction) {
        switch (reaction) {
            case "reaction-like":
                return <i className="fa fa-thumbs-up"></i>;
            case "reaction-love":
                return <i className="fa fa-heart fa-danger"></i>;
            case "reaction-haha":
                return <span style={{ fontSize: 16 }}>&#128513;</span>;
            case "reaction-wow":
                return <span style={{ fontSize: 16 }}>&#128516;</span>;
            case "reaction-sad":
                return <span style={{ fontSize: 16 }}>&#128532;</span>;
            case "reaction-angry":
                return <span style={{ fontSize: 16 }}>&#128544;</span>;
            default:
                return <span style={{ fontSize: 16 }}>&#128516;</span>;
        }
    }

    const handleRequestToJoin = () => {
        let isPeerExist = peers.filter(
            (z) => z.customerUserId === userProfile._id
        );
        if (isPeerExist.length > 0) {
            let newMetadata = JSON.parse(isPeerExist[0].metadata);
            newMetadata.isRequested = true;
            hmsActions.changeMetadata(newMetadata);
            Swal.fire({
                title: "Join as co-host?",
                text: "Please wait for the host to approve ",
                icon: "success",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                showConfirmButton: false,
                cancelButtonText: "Close",
                customClass: {
                    cancelButton: "order-1 right-gap",
                    confirmButton: "order-2",
                    denyButton: "order-3",
                },
            });
        }
    };

    const handleAudioMute = async () => {
        await hmsActions.setLocalAudioEnabled(!audioEnabled);
    };

    const handleVideoMute = async () => {
        await hmsActions.setLocalVideoEnabled(!videoEnabled);
    };

    if (!livestream._id) {
        return <p />;
    }

    let reactionCount = comments.filter((x) => x.type !== "comment");
    let currentRole = peers.filter((x) => x.customerUserId === userProfile._id);
    if (currentRole.length > 0) {
        currentRole = currentRole[0].roleName;
    }

    const shareUrl =
        process.env.REACT_APP_URL + "/video/" + livestream._id;
    const title = livestream.title;
    const requestedList = [];

    peers.forEach((x) => {
        if (x.metadata) {
            let newMetadata = JSON.parse(x.metadata);
            if (newMetadata.isRequested) {
                requestedList.push(x);
            }
        }
    });

    let sortedComments = [];
    // if (allMessages.length === 0) {
    sortedComments = comments.map((x) => {
        let req = {
            _id: x.infoUser._id,
            id: x._id,
            fullName: x.infoUser.fullName,
            image: getImage(x.infoUser.attachments),
            dateCreated: moment(x.dateCreated).format(),
            message: x.content,
            commentType: x.commentType ? x.commentType : "chat",
            pinned: x.pinned,
            isDB: true,
        };
        return req;
    });
    // // }
    // // else {
    // sortedComments = sortedComments.concat(allMessages.filter((x) => {
    //   let curPeer = _.find(peers, y => y.customerUserId === x.senderUserId);
    //   return curPeer && curPeer.id
    // }).map((x) => {
    //   let curPeer = _.find(peers, y => y.customerUserId === x.senderUserId);
    //   let req = {
    //     _id: JSON.parse(curPeer.metadata).id,
    //     id: x.message.id,
    //     fullName: curPeer.name,
    //     image: JSON.parse(curPeer.metadata).image,
    //     dateCreated: moment(x.time).format(),
    //     message: x.message,
    //     commentType: x.message === "joined@@@@" ? "joined" : x.message === "left####" ? "left" : "chat",
    //     pinned: x.read ? "no" : "yes",
    //     isDB: false
    //   };
    //   return req;
    // }))
    // // }

    // sortedComments = _.uniq(sortedComments, function (elem) { return [elem._id, elem.message].join(); });

    sortedComments = _.chain(sortedComments)
        .sortBy((o) => new moment(o.dateCreated))
        .sortBy((o) => o.pinned === "yes")
        .value();

    if (isEnd) {
        return <p></p>;
    }
    let selectedCategory = _.find(
        categories,
        (x) => x._id === livestream.category
    );

    return (
        <div className="px-2 sm:px-4 py-7 lg:p-0 lg:h-full lg:overflow-hidden">
            <Grid container spacing={2}>
                <Grid
                    id="fullScreening"
                    className={isFullScreen ? "fullScreening1" : ""}
                    item
                    xs={12}
                    sm={12}
                    lg={isFullScreen || isPIP ? 12 : 8}
                    md={isFullScreen || isPIP ? 12 : 8}
                >
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={12} lg={12} md={12}>
                            <canvas
                                id="canvas"
                                style={{ display: "none" }}
                            ></canvas>
                            {!isPIP ? (
                                <Hidden
                                    only={["xl", "md", "lg"]}
                                    className="mb-1"
                                    implementation="css"
                                >
                                    <div>
                                        <ul className="flex items-center space-x-5 pb-[7px] border-b border-black-10">
                                            <li>
                                                <a
                                                    onClick={() => {
                                                        setNewMessage(
                                                            false
                                                        );
                                                        setSelectedMenu(
                                                            "Chat1"
                                                        );
                                                    }}
                                                    className={`text-md cursor font-medium text-black-60 hover:text-orange-color pb-[7px] hover:border-b-2 border-orange-color capitalize px-5 view-profile-nav whitespace-nowrap ${selectedMenu ==
                                                        "Chat1"
                                                        ? "active"
                                                        : ""
                                                        }`}

                                                >
                                                    Chat
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    className={`text-md cursor font-medium text-black-60 hover:text-orange-color pb-[7px] hover:border-b-2 border-orange-color capitalize px-5 view-profile-nav whitespace-nowrap ${selectedMenu ==
                                                        "Info1"
                                                        ? "active"
                                                        : ""
                                                        }`}
                                                    onClick={() => {
                                                        setSelectedMenu(
                                                            "Info1"
                                                        );
                                                    }}
                                                >
                                                    Info
                                                </a>
                                            </li>
                                            {cartProducts.length > 0 && (
                                                <li>
                                                    <a
                                                        className={`text-md cursor font-medium text-black-60 hover:text-orange-color pb-[7px] hover:border-b-2 border-orange-color capitalize px-5 view-profile-nav whitespace-nowrap ${selectedMenu ==
                                                            "Product1"
                                                            ? "active"
                                                            : ""
                                                            }`}
                                                        onClick={() =>
                                                            setSelectedMenu(
                                                                "Product1"
                                                            )
                                                        }
                                                    >
                                                        Product
                                                    </a>
                                                </li>
                                            )}
                                            <li>
                                                <a
                                                    className={`text-md cursor font-medium text-black-60 hover:text-orange-color pb-[7px] hover:border-b-2 border-orange-color capitalize px-5 view-profile-nav whitespace-nowrap ${selectedMenu ==
                                                        "Audience1"
                                                        ? "active"
                                                        : ""
                                                        }`}
                                                    onClick={() =>
                                                        setSelectedMenu(
                                                            "Audience1"
                                                        )
                                                    }
                                                >
                                                    Audience
                                                </a>
                                            </li>
                                        </ul>
                                    </div>

                                    {/* <BottomNavigation
                    value={selectedMenu}
                    onChange={(event, newValue) => {
                      setSelectedMenu(newValue);
                    }}
                    showLabels
                    classes={{
                      root: "bottom-nav"
                    }}
                  >
                    <BottomNavigationAction value={"Chat1"} label="Chat" icon={<ChatIcon />} />
                    <BottomNavigationAction value={"Info1"} label="Info" icon={<InfoIcon />} />
                    {
                      cartProducts.length > 0 ?
                        <BottomNavigationAction value={"Product1"} label="Product" icon={<ShoppingBasketIcon />} />
                        : <></>
                    }
                    <BottomNavigationAction value={"Audience1"} label="Audience" icon={<PeopleIcon />} />
                  </BottomNavigation> */}

                                    <Grid
                                        container
                                        className="disp-none-mobile"
                                    >
                                        <Grid item xs={12} md={12}>
                                            <Dialog
                                                open={selectedMenu === "Chat1"}
                                                fullScreen
                                            >
                                                <DialogTitle>
                                                    Chat Details{" "}
                                                    <i
                                                        className="fa fa-close float-right"
                                                        onClick={() =>
                                                            setSelectedMenu("")
                                                        }
                                                    ></i>
                                                </DialogTitle>
                                                <DialogContent>
                                                    <div
                                                        className="chat-container"
                                                        style={{
                                                            marginBottom: 55,
                                                        }}
                                                    >
                                                        <div
                                                            className="chat-area"
                                                            style={{
                                                                height: "calc(100vh - 190px)",
                                                            }}
                                                        >
                                                            <List dense>
                                                                {sortedComments.map(
                                                                    (x) => {
                                                                        return (
                                                                            <>
                                                                                {x.commentType ===
                                                                                    "joined" ? (
                                                                                    <Alert
                                                                                        severity="info"
                                                                                        className="mb-1"
                                                                                    >
                                                                                        <strong>
                                                                                            {
                                                                                                x.fullName
                                                                                            }
                                                                                        </strong>{" "}
                                                                                        has
                                                                                        joined
                                                                                    </Alert>
                                                                                ) : x.commentType ===
                                                                                    "left" ||
                                                                                    x.commentType ===
                                                                                    "end" ? (
                                                                                    <Alert
                                                                                        severity="info"
                                                                                        className="mb-1"
                                                                                    >
                                                                                        <strong>
                                                                                            {
                                                                                                x.fullName
                                                                                            }
                                                                                        </strong>{" "}
                                                                                        has
                                                                                        left
                                                                                    </Alert>
                                                                                ) : (
                                                                                    <ListItem>
                                                                                        <ListItemAvatar>
                                                                                            <Avatar
                                                                                                onClick={() =>
                                                                                                    dispatch(
                                                                                                        fetchOtherUserProfileRequest(
                                                                                                            x._id,
                                                                                                            history
                                                                                                        )
                                                                                                    )
                                                                                                }
                                                                                                src={
                                                                                                    x.image
                                                                                                }
                                                                                                alt="pp"
                                                                                            />
                                                                                        </ListItemAvatar>
                                                                                        <ListItemText
                                                                                            primary={
                                                                                                x.fullName
                                                                                            }
                                                                                            secondary={
                                                                                                x.message
                                                                                            }
                                                                                        />
                                                                                        <ListItemSecondaryAction>
                                                                                            {moment(
                                                                                                x.dateCreated
                                                                                            ).fromNow()}
                                                                                            &nbsp;&nbsp;
                                                                                            {(x.pinned ==
                                                                                                "yes" ||
                                                                                                livestream
                                                                                                    .owner
                                                                                                    ._id ===
                                                                                                userProfile._id) && (
                                                                                                    <i
                                                                                                        className={`fa fa-thumb-tack ${x.pinned ==
                                                                                                            "yes"
                                                                                                            ? "active"
                                                                                                            : ""
                                                                                                            }`}
                                                                                                        onClick={() => {
                                                                                                            if (
                                                                                                                livestream
                                                                                                                    .owner
                                                                                                                    ._id ===
                                                                                                                userProfile._id
                                                                                                            ) {
                                                                                                                if (
                                                                                                                    x.isDB
                                                                                                                ) {
                                                                                                                    SocialAPI.UpdatePinComment(
                                                                                                                        x.id,
                                                                                                                        x.pinned ==
                                                                                                                            "yes"
                                                                                                                            ? "no"
                                                                                                                            : "yes"
                                                                                                                    ).then(
                                                                                                                        (
                                                                                                                            cm
                                                                                                                        ) => {
                                                                                                                            dispatch(
                                                                                                                                fetchEventRequest(
                                                                                                                                    "?where=livestream:" +
                                                                                                                                    livestream._id
                                                                                                                                )
                                                                                                                            );
                                                                                                                        }
                                                                                                                    );
                                                                                                                } else {
                                                                                                                    hmsActions.setMessageRead(
                                                                                                                        x.pinned ==
                                                                                                                            "no"
                                                                                                                            ? false
                                                                                                                            : true,
                                                                                                                        x.id
                                                                                                                    );
                                                                                                                }
                                                                                                            }
                                                                                                        }}
                                                                                                        style={{
                                                                                                            opacity:
                                                                                                                x.pinned ==
                                                                                                                    "yes"
                                                                                                                    ? 1
                                                                                                                    : 0.4,
                                                                                                            color: "red",
                                                                                                            display:
                                                                                                                x.pinned ==
                                                                                                                    "yes"
                                                                                                                    ? "inline-block"
                                                                                                                    : "inherit",
                                                                                                            transform:
                                                                                                                "rotate(30deg)",
                                                                                                        }}
                                                                                                    ></i>
                                                                                                )}
                                                                                        </ListItemSecondaryAction>
                                                                                    </ListItem>
                                                                                )}
                                                                            </>
                                                                        );
                                                                    }
                                                                )}
                                                            </List>
                                                        </div>
                                                        {comments &&
                                                            comments.filter(
                                                                (x) =>
                                                                    x.commentType ===
                                                                    "end"
                                                            ).length === 0 ? (
                                                            <TextField
                                                                autoComplete="off"
                                                                className="chat-textbox"
                                                                placeholder="Type message"
                                                                variant="outlined"
                                                                onKeyPress={(
                                                                    e
                                                                ) => {
                                                                    if (
                                                                        e.key ==
                                                                        "Enter"
                                                                    ) {
                                                                        sendComment();
                                                                    }
                                                                }}
                                                                inputProps={{
                                                                    id: "sendComment",
                                                                }}
                                                                InputProps={{
                                                                    endAdornment:
                                                                        (
                                                                            <InputAdornment position="end">
                                                                                <Button
                                                                                    onClick={() =>
                                                                                        sendComment()
                                                                                    }
                                                                                >
                                                                                    Send
                                                                                </Button>
                                                                            </InputAdornment>
                                                                        ),
                                                                }}
                                                            />
                                                        ) : (
                                                            <span />
                                                        )}
                                                    </div>
                                                </DialogContent>
                                            </Dialog>
                                            <Dialog
                                                open={selectedMenu === "Info1"}
                                                fullScreen
                                            >
                                                <DialogTitle>
                                                    Information{" "}
                                                    <i
                                                        className="fa fa-close float-right"
                                                        onClick={() =>
                                                            setSelectedMenu("")
                                                        }
                                                    ></i>
                                                </DialogTitle>
                                                <DialogContent>
                                                    <label className="text-bold">
                                                        Title
                                                    </label>
                                                    <TextField
                                                        fullWidth
                                                        disabled
                                                        variant="outlined"
                                                        value={livestream.title}
                                                        className="my-2"
                                                    />
                                                    <label className="text-bold">
                                                        Description
                                                    </label>
                                                    <TextField
                                                        fullWidth
                                                        disabled
                                                        variant="outlined"
                                                        value={
                                                            livestream.contents
                                                        }
                                                        multiline
                                                        minRows={3}
                                                        className="my-2"
                                                    />
                                                    {livestream.hashtags
                                                        .length > 0 && (
                                                            <label className="text-bold mb-2">
                                                                Hashtags
                                                            </label>
                                                        )}
                                                    <br />
                                                    {livestream.hashtags.map(
                                                        (x, index) => {
                                                            let cb =
                                                                tagColors.length >
                                                                    index
                                                                    ? tagColors[
                                                                    index
                                                                    ]
                                                                    : tagColors[0];
                                                            return (
                                                                <button
                                                                    className={
                                                                        "btn btn-sm btn-hash ml-2 " +
                                                                        cb
                                                                    }
                                                                >
                                                                    #{x || x.id}
                                                                    &nbsp;&nbsp;
                                                                </button>
                                                            );
                                                        }
                                                    )}

                                                    {livestream.attachments &&
                                                        selectedCategory.name !==
                                                        "VIP Circle" ? (
                                                        <div className="form-group">
                                                            <label className="text-bold my-2">
                                                                Thumbnail
                                                            </label>
                                                            <Box
                                                                display="flex"
                                                                alignItems="center"
                                                                justifyContent="center"
                                                            >
                                                                <Avatar
                                                                    variant="square"
                                                                    style={{
                                                                        height: 128,
                                                                        width: "100%",
                                                                    }}
                                                                    src={getImage(
                                                                        livestream.attachments
                                                                    )}
                                                                    alt="user profile image"
                                                                />
                                                            </Box>
                                                        </div>
                                                    ) : (
                                                        <span />
                                                    )}
                                                </DialogContent>
                                            </Dialog>
                                            <Dialog
                                                open={
                                                    selectedMenu === "Product1"
                                                }
                                                fullScreen
                                            >
                                                <DialogTitle>
                                                    Product{" "}
                                                    <i
                                                        className="fa fa-close float-right"
                                                        onClick={() =>
                                                            setSelectedMenu("")
                                                        }
                                                    ></i>
                                                </DialogTitle>
                                                <DialogContent>
                                                    <div className="">
                                                        {cartProducts &&
                                                            cartProducts.map(
                                                                (product) => {
                                                                    return (
                                                                        <div
                                                                            key={
                                                                                product._id
                                                                            }
                                                                            className="mb-5"
                                                                        >
                                                                            <div className="px-3.5 py-5 border border-black-10 rounded-md bg-white">
                                                                                <div className="grid grid-cols-2 gap-x-[18px]">
                                                                                    <div className="">
                                                                                        <ReactImageGallery
                                                                                            showNav={
                                                                                                false
                                                                                            }
                                                                                            showPlayButton={
                                                                                                false
                                                                                            }
                                                                                            items={
                                                                                                product
                                                                                                    .allAttachments
                                                                                                    .length >
                                                                                                    0
                                                                                                    ? product.allAttachments
                                                                                                        .concat(
                                                                                                            product.attachments
                                                                                                        )
                                                                                                        .map(
                                                                                                            (
                                                                                                                x
                                                                                                            ) => {
                                                                                                                return {
                                                                                                                    thumbnailWidth: 32,
                                                                                                                    thumbnailHeight: 32,
                                                                                                                    id: x._id,
                                                                                                                    original:
                                                                                                                        getImage(
                                                                                                                            x
                                                                                                                        ),
                                                                                                                    thumbnail:
                                                                                                                        getImage(
                                                                                                                            x
                                                                                                                        ),
                                                                                                                };
                                                                                                            }
                                                                                                        )
                                                                                                    : [
                                                                                                        {
                                                                                                            thumbnailWidth: 32,
                                                                                                            thumbnailHeight: 32,
                                                                                                            id: product
                                                                                                                .attachments
                                                                                                                ._id,
                                                                                                            original:
                                                                                                                getImage(
                                                                                                                    product.attachments
                                                                                                                ),
                                                                                                            thumbnail:
                                                                                                                getImage(
                                                                                                                    product.attachments
                                                                                                                ),
                                                                                                        },
                                                                                                    ]
                                                                                            }
                                                                                        />
                                                                                    </div>
                                                                                    <div className="">
                                                                                        <h5 className="text-extraSmall text-black-50">
                                                                                            {
                                                                                                product.name
                                                                                            }
                                                                                        </h5>
                                                                                        <p className="text-sm font-medium text-orange-color uppercase mb-1.5">
                                                                                            {
                                                                                                product.currency
                                                                                            }{" "}
                                                                                            {product.price.toFixed(
                                                                                                2
                                                                                            )}
                                                                                        </p>

                                                                                        <p className="text-extraSmall font-medium text-black capitalize mb-[1px]">
                                                                                            Stock
                                                                                            Quantity:{" "}
                                                                                            {
                                                                                                product
                                                                                                    .warehouse
                                                                                                    .quantity
                                                                                            }
                                                                                        </p>
                                                                                        <Tooltip
                                                                                            title={product.descriptions}
                                                                                        >
                                                                                            <p className="text-sm font-normal text-black-50">
                                                                                                {
                                                                                                    product.descriptions.length > 100
                                                                                                        ? product.descriptions.slice(0, 100) +
                                                                                                        "..."
                                                                                                        : product.descriptions
                                                                                                }
                                                                                            </p>
                                                                                        </Tooltip>
                                                                                    </div>
                                                                                </div>
                                                                                {livestream
                                                                                    .owner
                                                                                    ._id !==
                                                                                    userProfile._id ? (
                                                                                    <div className=" flex items-center gap-5 mt-5">
                                                                                        <button
                                                                                            onClick={() => {
                                                                                                dispatch(
                                                                                                    addCartRequest(
                                                                                                        {
                                                                                                            product:
                                                                                                                product._id,
                                                                                                            quantity: 1,
                                                                                                            livestream:
                                                                                                                livestream._id,
                                                                                                        }
                                                                                                    )
                                                                                                );
                                                                                            }}
                                                                                            className="py-[7px] w-full block capitalize rounded-lg text-sm font-medium bg-white border border-black-10 text-black-50 whitespace-nowrap"
                                                                                        >
                                                                                            Add
                                                                                            to
                                                                                            Cart
                                                                                        </button>
                                                                                        <button
                                                                                            onClick={() => {
                                                                                                dispatch(
                                                                                                    addCartRequest(
                                                                                                        {
                                                                                                            product:
                                                                                                                product._id,
                                                                                                            quantity: 1,
                                                                                                            livestream:
                                                                                                                livestream._id,
                                                                                                            history:
                                                                                                                history,
                                                                                                            canNavigate: true,
                                                                                                        }
                                                                                                    )
                                                                                                );
                                                                                            }}
                                                                                            className="py-[7px] w-full block capitalize rounded-lg text-sm font-bold bg-orange-color text-white whitespace-nowrap"
                                                                                        >
                                                                                            Buy
                                                                                            it
                                                                                            Now
                                                                                        </button>
                                                                                    </div>
                                                                                ) : (
                                                                                    <>

                                                                                    </>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                }
                                                            )}
                                                    </div>
                                                </DialogContent>
                                            </Dialog>
                                            <Dialog
                                                open={
                                                    selectedMenu === "Audience1"
                                                }
                                                fullScreen
                                            >
                                                <DialogTitle>
                                                    Audience{" "}
                                                    <i
                                                        className="fa fa-close float-right"
                                                        onClick={() =>
                                                            setSelectedMenu("")
                                                        }
                                                    ></i>
                                                </DialogTitle>
                                                <DialogContent>
                                                    <div
                                                        className="inner-glow"
                                                        style={{
                                                            minHeight:
                                                                "calc(100vh - 235px)",
                                                        }}
                                                    >
                                                        <p className="text-center mb-3">
                                                            <span className="text-bold">
                                                                {peers && peers.filter(s => s.name !== "Beam").length}
                                                            </span>{" "}
                                                            joined this live
                                                        </p>
                                                        {
                                                            peers && peers.filter(s => s.name !== "Beam").map((x) => {
                                                                let metadata =
                                                                    {};
                                                                if (
                                                                    !IsNullOrEmpty(
                                                                        x.metadata
                                                                    )
                                                                ) {
                                                                    metadata =
                                                                        JSON.parse(
                                                                            x.metadata
                                                                        );
                                                                }

                                                                return (
                                                                    <>
                                                                        <div className="py-[3px] pl-1.5 pr-4 flex items-center justify-between rounded-md border border-black-10 mb-2.5 cursor-pointer">
                                                                            <div className="flex items-center">
                                                                                <img
                                                                                    onClick={() => {
                                                                                        if (
                                                                                            userProfile._id ===
                                                                                            x.customerUserId
                                                                                        ) {
                                                                                            dispatch(
                                                                                                fetchUserProfileRequest(
                                                                                                    x.customerUserId
                                                                                                )
                                                                                            );
                                                                                            history(
                                                                                                "/" +
                                                                                                userProfile
                                                                                                    .account
                                                                                                    .userName
                                                                                            );
                                                                                        } else {
                                                                                            dispatch(
                                                                                                fetchOtherUserProfileRequest(
                                                                                                    x.customerUserId,
                                                                                                    history
                                                                                                )
                                                                                            );
                                                                                        }
                                                                                    }}
                                                                                    src={
                                                                                        metadata.image
                                                                                            ? metadata.image
                                                                                            : ProfilePic
                                                                                    }
                                                                                    alt=""
                                                                                    className="rounded-full w-[35px] aspect-square mr-2.5"
                                                                                />
                                                                                <h4 className="text-md font-medium text-ebony-color capitalize">
                                                                                    {
                                                                                        x.name
                                                                                    }
                                                                                </h4>
                                                                            </div>
                                                                            <span className="float-right">
                                                                                {livestream
                                                                                    .owner
                                                                                    ._id ===
                                                                                    userProfile._id &&
                                                                                    x.roleName ===
                                                                                    "guest" ? (
                                                                                    <button
                                                                                        className="py-1 px-2 bg-red-500 text-white text-sm capitalize rounded-lg whitespace-nowrap w-full sm:w-fit"
                                                                                        onClick={() =>
                                                                                            handleRemoveUser(
                                                                                                x
                                                                                            )
                                                                                        }
                                                                                    >
                                                                                        Remove
                                                                                        as
                                                                                        co-host
                                                                                    </button>
                                                                                ) : (
                                                                                    <>

                                                                                    </>
                                                                                )}
                                                                                {livestream
                                                                                    .owner
                                                                                    ._id ===
                                                                                    userProfile._id &&
                                                                                    x.roleName ===
                                                                                    "audience" &&
                                                                                    metadata.isRequested ? (
                                                                                    <button
                                                                                        className="py-1 px-2 bg-orange-color text-white text-sm capitalize rounded-lg whitespace-nowrap w-full sm:w-fit"
                                                                                        onClick={() =>
                                                                                            handleAddUser(
                                                                                                x
                                                                                            )
                                                                                        }
                                                                                    >
                                                                                        Accept
                                                                                        as
                                                                                        co-host
                                                                                    </button>
                                                                                ) : (
                                                                                    <>

                                                                                    </>
                                                                                )}
                                                                            </span>
                                                                        </div>
                                                                    </>
                                                                );
                                                            })
                                                        }
                                                    </div>
                                                </DialogContent>
                                            </Dialog>
                                        </Grid>
                                    </Grid>
                                </Hidden>
                            ) : (
                                <></>
                            )}
                            <Grid container spacing={1}>
                                <Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    lg={3}
                                    md={3}
                                    alignItems="center"
                                >
                                    {!isPIP ? (
                                        !isFullScreen && (
                                            <Hidden
                                                only={["lg", "xl", "md"]}
                                                implementation="js"
                                            >
                                                <Carousel
                                                    autoPlay={false}
                                                    responsive={responsive}
                                                >
                                                    {roomDetail.id &&
                                                        !IsNullOrEmpty(token) ? (
                                                        peers
                                                            .filter(
                                                                (x) =>
                                                                    !IsNullOrEmpty(
                                                                        x.metadata
                                                                    ) &&
                                                                    x.roleName !==
                                                                    "audience"
                                                            )
                                                            .map((peer) => (
                                                                <Card
                                                                    elevation={0}
                                                                    variant="elevation"
                                                                    className="mb-2 mr-2"
                                                                    key={
                                                                        peer.id
                                                                    }
                                                                    onClick={() =>
                                                                        setSelectedUser(
                                                                            peer.customerUserId
                                                                        )
                                                                    }
                                                                >
                                                                    <CardContent className="p-1">
                                                                        <Box
                                                                            textAlign="center"
                                                                            display="flex"
                                                                            flexDirection="column"
                                                                            justifyContent="center"
                                                                            alignItems="center"
                                                                        >
                                                                            <Peer
                                                                                devices={
                                                                                    devices
                                                                                }
                                                                                isFullScreen={
                                                                                    isFullScreen
                                                                                }
                                                                                isOwner={
                                                                                    livestream
                                                                                        .owner
                                                                                        ._id ===
                                                                                    userProfile._id
                                                                                }
                                                                                peersCount={
                                                                                    peers.length
                                                                                }
                                                                                comments={
                                                                                    livestream.guestStats
                                                                                }
                                                                                isSide={
                                                                                    true
                                                                                }
                                                                                css=""
                                                                                isPIP={
                                                                                    isPIP
                                                                                }
                                                                                peer={
                                                                                    peer
                                                                                }
                                                                                isZoomIn={
                                                                                    peer.customerUserId !==
                                                                                    selectedUser
                                                                                }
                                                                                videoEnabled={
                                                                                    videoEnabled
                                                                                }
                                                                            />
                                                                        </Box>

                                                                        {/* {peer.customerUserId !==
                                                                            selectedUser && (
                                                                                <List
                                                                                    disablePadding
                                                                                    style={{
                                                                                        height: 24,
                                                                                        left: 4,
                                                                                        position:
                                                                                            "absolute",
                                                                                        zIndex: 1,
                                                                                        bottom: 0,
                                                                                        background:
                                                                                            "rgba(0,0,0,0.1)",
                                                                                        color: "white",
                                                                                        width: "90%",
                                                                                        marginBottom: 16,
                                                                                    }}
                                                                                >
                                                                                    <ListItem
                                                                                        disableGutters
                                                                                        classes={{
                                                                                            root: "p-0",
                                                                                        }}
                                                                                    >
                                                                                        <ListItemAvatar>
                                                                                            <Avatar
                                                                                                style={{
                                                                                                    width: 16,
                                                                                                    height: 16,
                                                                                                }}
                                                                                                src={
                                                                                                    JSON.parse(
                                                                                                        peer.metadata
                                                                                                    )
                                                                                                        .image
                                                                                                }
                                                                                            />
                                                                                        </ListItemAvatar>
                                                                                        <ListItemText
                                                                                            primary={
                                                                                                <span className="text-small overflow-text">
                                                                                                    {
                                                                                                        peer.name
                                                                                                    }
                                                                                                </span>
                                                                                            }
                                                                                        />
                                                                                    </ListItem>
                                                                                </List>
                                                                            )} */}
                                                                    </CardContent>
                                                                </Card>
                                                            ))
                                                    ) : (
                                                        <></>
                                                    )}
                                                </Carousel>
                                            </Hidden>
                                        )
                                    ) : (
                                        <></>
                                    )}
                                    <Hidden
                                        only={["sm", "xs"]}
                                        implementation="js"
                                    >
                                        <ul
                                            className="guest-list-top p-2"
                                            style={{
                                                overflowY: "auto",
                                                maxHeight: isPIP
                                                    ? "35vh"
                                                    : "calc(100vh - 152px)",
                                            }}
                                        >
                                            {roomDetail.id &&
                                                !IsNullOrEmpty(token) ? (
                                                peers
                                                    .filter(
                                                        (x) =>
                                                            !IsNullOrEmpty(
                                                                x.metadata
                                                            ) &&
                                                            x.roleName !==
                                                            "audience"
                                                    )
                                                    .map((peer) => (
                                                        <li
                                                            style={{
                                                                display:
                                                                    "block",
                                                                width: "97%",
                                                            }}
                                                        >
                                                            <Card
                                                                elevation={0}
                                                                className="mb-2"
                                                                key={peer.id}
                                                                onClick={() =>
                                                                    setSelectedUser(
                                                                        peer.customerUserId
                                                                    )
                                                                }
                                                            >
                                                                <CardContent className="p-1">
                                                                    <Box
                                                                        textAlign="center"
                                                                        display="flex"
                                                                        flexDirection="column"
                                                                        justifyContent="center"
                                                                        alignItems="center"
                                                                    >
                                                                        <Peer
                                                                            devices={
                                                                                devices
                                                                            }
                                                                            isFullScreen={
                                                                                isFullScreen
                                                                            }
                                                                            isOwner={
                                                                                livestream
                                                                                    .owner
                                                                                    ._id ===
                                                                                userProfile._id
                                                                            }
                                                                            peersCount={
                                                                                peers.length
                                                                            }
                                                                            comments={
                                                                                livestream.guestStats
                                                                            }
                                                                            isSide={
                                                                                true
                                                                            }
                                                                            css=""
                                                                            isPIP={
                                                                                isPIP
                                                                            }
                                                                            peer={
                                                                                peer
                                                                            }
                                                                            isZoomIn={
                                                                                peer.customerUserId !==
                                                                                selectedUser
                                                                            }
                                                                            videoEnabled={
                                                                                videoEnabled
                                                                            }
                                                                        />
                                                                    </Box>
                                                                    {peer.customerUserId !==
                                                                        selectedUser && (
                                                                            <List
                                                                                disablePadding
                                                                            >
                                                                                <ListItem
                                                                                    disableGutters
                                                                                    style={{
                                                                                        height: 24,
                                                                                        left: 4,
                                                                                        position:
                                                                                            "absolute",
                                                                                        zIndex: 1,
                                                                                        bottom: 0,
                                                                                        background:
                                                                                            "rgba(0,0,0,0.1)",
                                                                                        color: "white",
                                                                                    }}
                                                                                    classes={{
                                                                                        root: "p-0",
                                                                                    }}
                                                                                >
                                                                                    <ListItemAvatar>
                                                                                        <Avatar
                                                                                            style={{
                                                                                                width: 16,
                                                                                                height: 16,
                                                                                            }}
                                                                                            src={
                                                                                                JSON.parse(
                                                                                                    peer.metadata
                                                                                                )
                                                                                                    .image
                                                                                            }
                                                                                        />
                                                                                    </ListItemAvatar>
                                                                                    <ListItemText
                                                                                        primary={
                                                                                            <span className="text-small">
                                                                                                {
                                                                                                    peer.name
                                                                                                }
                                                                                            </span>
                                                                                        }
                                                                                    />
                                                                                </ListItem>
                                                                            </List>
                                                                        )}
                                                                </CardContent>
                                                            </Card>
                                                        </li>
                                                    ))
                                            ) : (
                                                <></>
                                            )}
                                        </ul>
                                    </Hidden>
                                </Grid>
                                <Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    lg={9}
                                    md={9}
                                    alignItems="center"
                                    alignContent="center"
                                >
                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        flexDirection="column"
                                        className="pt-2"
                                    >
                                        {roomDetail.id &&
                                            !IsNullOrEmpty(token) ? (
                                            peers
                                                .filter(
                                                    (x) =>
                                                        x.customerUserId ===
                                                        selectedUser &&
                                                        !IsNullOrEmpty(
                                                            x.metadata
                                                        )
                                                )
                                                .map((peer) => (
                                                    <>
                                                        <Peer
                                                            devices={devices}
                                                            isOwner={
                                                                livestream.owner
                                                                    ._id ===
                                                                userProfile._id
                                                            }
                                                            onToggleFullScreen={() => {
                                                                if (
                                                                    isFullScreen
                                                                ) {
                                                                    if (
                                                                        document.exitFullscreen
                                                                    ) {
                                                                        document.exitFullscreen();
                                                                    } else if (
                                                                        document.mozCancelFullScreen
                                                                    ) {
                                                                        document.mozCancelFullScreen();
                                                                    } else if (
                                                                        document.webkitExitFullscreen
                                                                    ) {
                                                                        document.webkitExitFullscreen();
                                                                    } else if (
                                                                        document.msExitFullscreen
                                                                    ) {
                                                                        document.msExitFullscreen();
                                                                    }
                                                                }
                                                                setFullScreen(
                                                                    !isFullScreen
                                                                );
                                                            }}
                                                            isFullScreen={
                                                                isFullScreen
                                                            }
                                                            peersCount={
                                                                peers.length
                                                            }
                                                            comments={
                                                                livestream.guestStats
                                                            }
                                                            css="peer-zoomin"
                                                            isPIP={isPIP}
                                                            key={peer.id}
                                                            peer={peer}
                                                            isZoomIn={true}
                                                            videoEnabled={
                                                                videoEnabled
                                                            }
                                                        />
                                                        <List
                                                            disablePadding
                                                            className={
                                                                isPIP
                                                                    ? "video-thumb disp-none-mobile"
                                                                    : "video-thumb"
                                                            }
                                                        >
                                                            <ListItem
                                                                disableGutters
                                                                classes={{
                                                                    root: "p-0",
                                                                }}
                                                            >
                                                                <ListItemAvatar>
                                                                    <Avatar
                                                                        src={
                                                                            JSON.parse(
                                                                                peer.metadata
                                                                            )
                                                                                .image
                                                                        }
                                                                    />
                                                                </ListItemAvatar>
                                                                <ListItemText
                                                                    primary={
                                                                        peer.name
                                                                    }
                                                                    secondary={
                                                                        peer.roleName &&
                                                                        peer.roleName.toUpperCase()
                                                                    }
                                                                />
                                                            </ListItem>
                                                        </List>
                                                    </>
                                                ))
                                        ) : (
                                            <></>
                                        )}
                                    </Box>
                                </Grid>
                            </Grid>

                            <Grid
                                item
                                xs={12}
                                sm={12}
                                lg={12}
                                md={12}
                                className={
                                    isPIP ? "mt-4 disp-none-mobile" : "mt-4"
                                }
                            >
                                {disableControl ? (
                                    <span />
                                ) : localPeer &&
                                    localPeer.roleName === "audience" ? (
                                    <Grid
                                        container
                                        alignItems="center"
                                        justifyContent="center"
                                    >
                                        <Grid item sm={2} xs={2} md={2} lg={2}>
                                            <Button
                                                variant="contained"
                                                className="end-live-btn btn bg-danger text-white"
                                                onClick={() => handleEnd()}
                                            >
                                                Exit Live
                                            </Button>
                                        </Grid>
                                        <Grid
                                            item
                                            sm={10}
                                            xs={10}
                                            md={10}
                                            lg={10}
                                        >
                                            <Box
                                                display="flex"
                                                alignItems="center"
                                                justifyContent="center"
                                            >
                                                <div className="flex mx-2 items-center text-black-60 hover:text-orange-color cursor-pointer">
                                                    <span>
                                                        <svg
                                                            onClick={() => {
                                                                if (isPIP) {
                                                                    history(
                                                                        "/page/livestream"
                                                                    );
                                                                } else {
                                                                    if (
                                                                        isFullScreen
                                                                    ) {
                                                                        if (
                                                                            document.exitFullscreen
                                                                        ) {
                                                                            document.exitFullscreen();
                                                                        } else if (
                                                                            document.mozCancelFullScreen
                                                                        ) {
                                                                            document.mozCancelFullScreen();
                                                                        } else if (
                                                                            document.webkitExitFullscreen
                                                                        ) {
                                                                            document.webkitExitFullscreen();
                                                                        } else if (
                                                                            document.msExitFullscreen
                                                                        ) {
                                                                            document.msExitFullscreen();
                                                                        }
                                                                    }
                                                                    setFullScreen(
                                                                        !isFullScreen
                                                                    );
                                                                }
                                                            }}
                                                            width="21"
                                                            height="21"
                                                            viewBox="0 0 21 21"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <path
                                                                d="M1.5 6V1.5M1.5 1.5H6M1.5 1.5L7.125 7.125M19.5 6V1.5M19.5 1.5H15M19.5 1.5L13.875 7.125M1.5 15V19.5M1.5 19.5H6M1.5 19.5L7.125 13.875M19.5 19.5L13.875 13.875M19.5 19.5V15M19.5 19.5H15"
                                                                stroke="black"
                                                                stroke-opacity="0.3"
                                                                stroke-width="1.6875"
                                                                stroke-linecap="round"
                                                                stroke-linejoin="round"
                                                            />
                                                        </svg>
                                                    </span>
                                                </div>
                                                <div className="flex items-center text-black-60 hover:text-orange-color cursor-pointer">
                                                    <span>
                                                        <svg
                                                            onClick={() =>
                                                                setShared(true)
                                                            }
                                                            width="20"
                                                            height="20"
                                                            viewBox="0 0 20 20"
                                                            className="stroke-current  mr-1.5 md:mr-2.5"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <path
                                                                d="M6.68387 11.3419C6.88616 10.9381 7 10.4824 7 10C7 9.51763 6.88616 9.06185 6.68387 8.65807M6.68387 11.3419C6.19134 12.3251 5.17449 13 4 13C2.34315 13 1 11.6569 1 10C1 8.34315 2.34315 7 4 7C5.17449 7 6.19134 7.67492 6.68387 8.65807M6.68387 11.3419L13.3161 14.6581M6.68387 8.65807L13.3161 5.34193M13.3161 5.34193C13.8087 6.32508 14.8255 7 16 7C17.6569 7 19 5.65685 19 4C19 2.34315 17.6569 1 16 1C14.3431 1 13 2.34315 13 4C13 4.48237 13.1138 4.93815 13.3161 5.34193ZM13.3161 14.6581C13.1138 15.0619 13 15.5176 13 16C13 17.6569 14.3431 19 16 19C17.6569 19 19 17.6569 19 16C19 14.3431 17.6569 13 16 13C14.8255 13 13.8087 13.6749 13.3161 14.6581Z"
                                                                strokeWidth="1.5"
                                                                stroke="black"
                                                                stroke-opacity="0.3"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            />
                                                        </svg>
                                                    </span>
                                                </div>
                                                <div className="flex items-center text-black-60 hover:text-orange-color cursor-pointer">
                                                    <span>
                                                        <svg
                                                            onClick={() => {
                                                                if (
                                                                    !livestream.isBookmark
                                                                ) {
                                                                    dispatch(
                                                                        createBookMarkRequest(
                                                                            {
                                                                                livestream:
                                                                                    livestream._id,
                                                                            }
                                                                        )
                                                                    );
                                                                }
                                                            }}
                                                            width="22"
                                                            height="20"
                                                            viewBox="0 0 22 20"
                                                            className="stroke-current  mr-1.5 md:mr-2.5"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <path
                                                                d="M10.049 1.92664C10.3483 1.00537 11.6517 1.00538 11.951 1.92664L13.4699 6.60055C13.6038 7.01254 13.9877 7.29148 14.4209 7.29149L19.3354 7.29168C20.3041 7.29172 20.7068 8.53127 19.9232 9.10067L15.9474 11.9895C15.5969 12.2441 15.4503 12.6955 15.5841 13.1075L17.1026 17.7815C17.4019 18.7028 16.3475 19.4689 15.5638 18.8995L11.5878 16.011C11.2373 15.7564 10.7627 15.7564 10.4122 16.011L6.43622 18.8995C5.65252 19.4689 4.5981 18.7028 4.8974 17.7815L6.41589 13.1075C6.54974 12.6955 6.40309 12.2441 6.05263 11.9895L2.07683 9.10067C1.29317 8.53127 1.69592 7.29172 2.66461 7.29168L7.57911 7.29149C8.01231 7.29148 8.39623 7.01254 8.53011 6.60055L10.049 1.92664Z"
                                                                stroke={
                                                                    livestream.isBookmark
                                                                        ? "#7900F8"
                                                                        : "black"
                                                                }
                                                                strokeOpacity={
                                                                    0.3
                                                                }
                                                                strokeWidth="1.5"
                                                            />
                                                        </svg>
                                                    </span>
                                                    <button
                                                        disabled={
                                                            livestream.isBookmark
                                                        }
                                                        className="text-sm font-medium capitalize"
                                                    ></button>
                                                </div>
                                                <div className="flex items-center text-black-60 hover:text-orange-color cursor-pointer">
                                                    <svg
                                                        onClick={() => {
                                                            handleRequestToJoin();
                                                        }}
                                                        width="25"
                                                        height="22"
                                                        viewBox="0 0 25 22"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M19.4986 18.06C20.9237 18.1765 22.3574 17.9929 23.7072 17.5211C23.7588 16.8859 23.6294 16.2491 23.3341 15.6844C23.0388 15.1197 22.5897 14.6501 22.0387 14.33C21.4876 14.0099 20.8572 13.8523 20.2204 13.8755C19.5835 13.8987 18.9663 14.1017 18.44 14.4611M19.4975 18.0589L19.4986 18.0938C19.4986 18.3469 19.4851 18.5966 19.457 18.843C17.4155 20.0143 15.1022 20.6288 12.7486 20.625C10.3074 20.625 8.01574 19.977 6.04024 18.843C6.01131 18.5826 5.99741 18.3208 5.99861 18.0589M19.4986 18.0589C19.4942 16.7838 19.1271 15.5364 18.44 14.4623M18.44 14.4623C17.8301 13.5058 16.9889 12.7185 15.994 12.1734C14.9992 11.6283 13.883 11.343 12.7486 11.3438C11.6144 11.3432 10.4984 11.6286 9.50381 12.1737C8.5092 12.7188 7.66811 13.5059 7.05836 14.4623M7.05836 14.4623C6.5321 14.1032 5.91496 13.9004 5.27829 13.8774C4.64163 13.8544 4.01145 14.012 3.46061 14.3321C2.90978 14.6521 2.46078 15.1216 2.16554 15.6861C1.8703 16.2507 1.74088 16.8872 1.79223 17.5223C3.14101 17.9967 4.57507 18.1795 5.99973 18.0589M7.05724 14.4623C6.37056 15.5365 6.00378 16.7839 5.99973 18.0589M16.1236 4.59375C16.1236 5.48886 15.768 6.3473 15.1351 6.98024C14.5022 7.61317 13.6437 7.96875 12.7486 7.96875C11.8535 7.96875 10.9951 7.61317 10.3621 6.98024C9.72919 6.3473 9.37361 5.48886 9.37361 4.59375C9.37361 3.69864 9.72919 2.8402 10.3621 2.20726C10.9951 1.57433 11.8535 1.21875 12.7486 1.21875C13.6437 1.21875 14.5022 1.57433 15.1351 2.20726C15.768 2.8402 16.1236 3.69864 16.1236 4.59375V4.59375ZM22.8736 7.96875C22.8736 8.30116 22.8081 8.63031 22.6809 8.93742C22.5537 9.24452 22.3673 9.52357 22.1322 9.75861C21.8972 9.99366 21.6181 10.1801 21.311 10.3073C21.0039 10.4345 20.6748 10.5 20.3424 10.5C20.01 10.5 19.6808 10.4345 19.3737 10.3073C19.0666 10.1801 18.7875 9.99366 18.5525 9.75861C18.3174 9.52357 18.131 9.24452 18.0038 8.93742C17.8766 8.63031 17.8111 8.30116 17.8111 7.96875C17.8111 7.29742 18.0778 6.65359 18.5525 6.17889C19.0272 5.70418 19.671 5.4375 20.3424 5.4375C21.0137 5.4375 21.6575 5.70418 22.1322 6.17889C22.6069 6.65359 22.8736 7.29742 22.8736 7.96875V7.96875ZM7.68611 7.96875C7.68611 8.30116 7.62064 8.63031 7.49343 8.93742C7.36622 9.24452 7.17977 9.52357 6.94472 9.75861C6.70968 9.99366 6.43063 10.1801 6.12353 10.3073C5.81642 10.4345 5.48727 10.5 5.15486 10.5C4.82245 10.5 4.4933 10.4345 4.18619 10.3073C3.87909 10.1801 3.60004 9.99366 3.365 9.75861C3.12995 9.52357 2.9435 9.24452 2.81629 8.93742C2.68908 8.63031 2.62361 8.30116 2.62361 7.96875C2.62361 7.29742 2.89029 6.65359 3.365 6.17889C3.8397 5.70418 4.48353 5.4375 5.15486 5.4375C5.82619 5.4375 6.47002 5.70418 6.94472 6.17889C7.41943 6.65359 7.68611 7.29742 7.68611 7.96875V7.96875Z"
                                                            stroke={
                                                                isRequestToJoin
                                                                    ? "orange"
                                                                    : "black"
                                                            }
                                                            stroke-opacity={
                                                                isRequestToJoin
                                                                    ? "1"
                                                                    : "0.3"
                                                            }
                                                            stroke-width="1.6875"
                                                            stroke-linecap="round"
                                                            stroke-linejoin="round"
                                                        />
                                                    </svg>
                                                </div>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                ) : (
                                    <div class="flex items-center justify-center relative"
                                    >
                                        <Hidden
                                            only={["sm", "xs"]}
                                            implementation="js"
                                        >
                                            {!isFullScreen && (
                                                <Button
                                                    variant="contained"
                                                    className="end-live-btn btn bg-danger text-white absolute left-0"
                                                    onClick={() => {
                                                        Swal.fire({
                                                            title:
                                                                livestream
                                                                    .owner
                                                                    ._id ===
                                                                    userProfile._id
                                                                    ? "End live?"
                                                                    : "Leave live?",
                                                            html:
                                                                livestream
                                                                    .owner
                                                                    ._id ===
                                                                    userProfile._id
                                                                    ? `<p class="text-grey">Your live will be stopped and stored in your profile</p>`
                                                                    : `<p class="text-grey">Your live will be stopped.</p>`,
                                                            icon: "question",
                                                            customClass: {
                                                                icon: "disp-none",
                                                                actions:
                                                                    "my-actions",
                                                                cancelButton:
                                                                    "order-1 right-gap",
                                                                confirmButton:
                                                                    "order-2",
                                                                denyButton:
                                                                    "order-3",
                                                            },
                                                            showCancelButton: true,
                                                            cancelButtonText:
                                                                "Cancel",
                                                            confirmButtonText:
                                                                "Confirm",
                                                        }).then(
                                                            (result) => {
                                                                if (
                                                                    result.isConfirmed
                                                                ) {
                                                                    handleEnd();
                                                                }
                                                            }
                                                        );
                                                    }}
                                                >
                                                    Exit Live
                                                </Button>
                                            )}
                                        </Hidden>

                                        <Box
                                            display="flex"
                                            alignItems="center"
                                            justifyContent="center"
                                        >
                                            <Hidden
                                                only={["xl", "lg", "md"]}
                                                implementation="js"
                                            >
                                                <IconButton
                                                    variant="contained"
                                                    color="primary"
                                                    className="end-live-btn btn"
                                                    onClick={() => {
                                                        Swal.fire({
                                                            title:
                                                                livestream.owner
                                                                    ._id ===
                                                                    userProfile._id
                                                                    ? "End live?"
                                                                    : "Leave live?",
                                                            html: `<p class="text-grey">Your live will be stopped and stored in your profile</p>`,
                                                            icon: "question",
                                                            customClass: {
                                                                icon: "disp-none",
                                                                actions:
                                                                    "my-actions",
                                                                cancelButton:
                                                                    "order-1 right-gap",
                                                                confirmButton:
                                                                    "order-2",
                                                                denyButton:
                                                                    "order-3",
                                                            },
                                                            showCancelButton: true,
                                                            cancelButtonText:
                                                                "Cancel",
                                                            confirmButtonText:
                                                                "Confirm",
                                                        }).then((result) => {
                                                            if (
                                                                result.isConfirmed
                                                            ) {
                                                                handleEnd();
                                                            }
                                                        });
                                                    }}
                                                >
                                                    <Cancel
                                                        htmlColor="grey"
                                                        fontSize="large"
                                                    />
                                                </IconButton>
                                            </Hidden>
                                            <div className="flex mx-2 items-center text-black-60 hover:text-orange-color cursor-pointer">
                                                <span>
                                                    <svg
                                                        onClick={() => {
                                                            if (isPIP) {
                                                                history(
                                                                    "/page/livestream"
                                                                );
                                                            } else {
                                                                if (
                                                                    isFullScreen
                                                                ) {
                                                                    if (
                                                                        document.exitFullscreen
                                                                    ) {
                                                                        document.exitFullscreen();
                                                                    } else if (
                                                                        document.mozCancelFullScreen
                                                                    ) {
                                                                        document.mozCancelFullScreen();
                                                                    } else if (
                                                                        document.webkitExitFullscreen
                                                                    ) {
                                                                        document.webkitExitFullscreen();
                                                                    } else if (
                                                                        document.msExitFullscreen
                                                                    ) {
                                                                        document.msExitFullscreen();
                                                                    }
                                                                }
                                                                setFullScreen(
                                                                    !isFullScreen
                                                                );
                                                            }
                                                        }}
                                                        width="21"
                                                        height="21"
                                                        viewBox="0 0 21 21"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M1.5 6V1.5M1.5 1.5H6M1.5 1.5L7.125 7.125M19.5 6V1.5M19.5 1.5H15M19.5 1.5L13.875 7.125M1.5 15V19.5M1.5 19.5H6M1.5 19.5L7.125 13.875M19.5 19.5L13.875 13.875M19.5 19.5V15M19.5 19.5H15"
                                                            stroke="black"
                                                            stroke-opacity="0.3"
                                                            stroke-width="1.6875"
                                                            stroke-linecap="round"
                                                            stroke-linejoin="round"
                                                        />
                                                    </svg>
                                                </span>
                                            </div>

                                            <div className="flex  mx-2 items-center text-black-60 hover:text-orange-color cursor-pointer">
                                                <span>
                                                    <svg
                                                        width="23"
                                                        onClick={() =>
                                                            handleVideoMute()
                                                        }
                                                        opacity={
                                                            !videoEnabled
                                                                ? 0.5
                                                                : 1
                                                        }
                                                        height="17"
                                                        viewBox="0 0 23 17"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M14.75 6.25L19.8719 3.68906C20.6199 3.31505 21.5 3.85898 21.5 4.69529V12.3047C21.5 13.141 20.6199 13.6849 19.8719 13.3109L14.75 10.75M3.5 15.25H12.5C13.7426 15.25 14.75 14.2426 14.75 13V4C14.75 2.75736 13.7426 1.75 12.5 1.75H3.5C2.25736 1.75 1.25 2.75736 1.25 4V13C1.25 14.2426 2.25736 15.25 3.5 15.25Z"
                                                            stroke="#7900F8"
                                                            stroke-width="1.6875"
                                                            stroke-linecap="round"
                                                            stroke-linejoin="round"
                                                        />
                                                    </svg>
                                                </span>
                                            </div>
                                            <div className="flex  mx-2 items-center text-black-60 hover:text-orange-color cursor-pointer">
                                                <span>
                                                    <svg
                                                        onClick={() =>
                                                            handleAudioMute()
                                                        }
                                                        opacity={
                                                            !audioEnabled
                                                                ? 0.5
                                                                : 1
                                                        }
                                                        width="18"
                                                        height="25"
                                                        viewBox="0 0 18 25"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M17.125 11.375C17.125 15.7242 13.5992 19.25 9.25 19.25M9.25 19.25C4.90076 19.25 1.375 15.7242 1.375 11.375M9.25 19.25V23.75M9.25 23.75H4.75M9.25 23.75H13.75M9.25 14.75C7.38604 14.75 5.875 13.239 5.875 11.375V4.625C5.875 2.76104 7.38604 1.25 9.25 1.25C11.114 1.25 12.625 2.76104 12.625 4.625V11.375C12.625 13.239 11.114 14.75 9.25 14.75Z"
                                                            stroke="#7900F8"
                                                            stroke-width="1.6875"
                                                            stroke-linecap="round"
                                                            stroke-linejoin="round"
                                                        />
                                                    </svg>
                                                </span>
                                            </div>

                                            <div
                                                onClick={async () => {
                                                    try {
                                                        if (
                                                            !presenter ||
                                                            !presenter.id
                                                        ) {
                                                            await hmsActions.setScreenShareEnabled(
                                                                true
                                                            );
                                                        }
                                                    } catch (ex) {
                                                        console.log(ex);
                                                    }
                                                }}
                                                className="flex  mx-2 items-center text-black-60 hover:text-orange-color cursor-pointer"
                                            >
                                                <span>
                                                    <svg
                                                        opacity={
                                                            !presenter ||
                                                                !presenter.id
                                                                ? 1
                                                                : 0.5
                                                        }
                                                        width="23"
                                                        height="23"
                                                        viewBox="0 0 23 23"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M8.59375 17.125L7.75 20.5L6.625 21.625H15.625L14.5 20.5L13.6562 17.125M1 12.625H21.25M3.25 17.125H19C20.2426 17.125 21.25 16.1176 21.25 14.875V3.625C21.25 2.38236 20.2426 1.375 19 1.375H3.25C2.00736 1.375 1 2.38236 1 3.625V14.875C1 16.1176 2.00736 17.125 3.25 17.125Z"
                                                            stroke="black"
                                                            stroke-opacity="0.3"
                                                            stroke-width="1.6875"
                                                            stroke-linecap="round"
                                                            stroke-linejoin="round"
                                                        />
                                                    </svg>
                                                </span>
                                            </div>
                                            <div className="flex items-center text-black-60 hover:text-orange-color cursor-pointer">
                                                <span>
                                                    <svg
                                                        onClick={() => {
                                                            if (
                                                                !livestream.isBookmark
                                                            ) {
                                                                dispatch(
                                                                    createBookMarkRequest(
                                                                        {
                                                                            livestream:
                                                                                livestream._id,
                                                                        }
                                                                    )
                                                                );
                                                            }
                                                        }}
                                                        width="22"
                                                        height="20"
                                                        viewBox="0 0 22 20"
                                                        className="stroke-current  mr-1.5 md:mr-2.5"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M10.049 1.92664C10.3483 1.00537 11.6517 1.00538 11.951 1.92664L13.4699 6.60055C13.6038 7.01254 13.9877 7.29148 14.4209 7.29149L19.3354 7.29168C20.3041 7.29172 20.7068 8.53127 19.9232 9.10067L15.9474 11.9895C15.5969 12.2441 15.4503 12.6955 15.5841 13.1075L17.1026 17.7815C17.4019 18.7028 16.3475 19.4689 15.5638 18.8995L11.5878 16.011C11.2373 15.7564 10.7627 15.7564 10.4122 16.011L6.43622 18.8995C5.65252 19.4689 4.5981 18.7028 4.8974 17.7815L6.41589 13.1075C6.54974 12.6955 6.40309 12.2441 6.05263 11.9895L2.07683 9.10067C1.29317 8.53127 1.69592 7.29172 2.66461 7.29168L7.57911 7.29149C8.01231 7.29148 8.39623 7.01254 8.53011 6.60055L10.049 1.92664Z"
                                                            stroke={
                                                                livestream.isBookmark
                                                                    ? "#7900F8"
                                                                    : "#000000"
                                                            }
                                                            strokeOpacity={
                                                                0.3
                                                            }
                                                            strokeWidth="1.5"
                                                        />
                                                    </svg>
                                                </span>
                                                <button
                                                    disabled={
                                                        livestream.isBookmark
                                                    }
                                                    className="text-sm font-medium capitalize"
                                                ></button>
                                            </div>
                                            <div className="flex items-center text-black-60 hover:text-orange-color cursor-pointer">
                                                <span>
                                                    <svg
                                                        onClick={() =>
                                                            setShared(true)
                                                        }
                                                        width="20"
                                                        height="20"
                                                        viewBox="0 0 20 20"
                                                        className="stroke-current  mr-1.5 md:mr-2.5"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M6.68387 11.3419C6.88616 10.9381 7 10.4824 7 10C7 9.51763 6.88616 9.06185 6.68387 8.65807M6.68387 11.3419C6.19134 12.3251 5.17449 13 4 13C2.34315 13 1 11.6569 1 10C1 8.34315 2.34315 7 4 7C5.17449 7 6.19134 7.67492 6.68387 8.65807M6.68387 11.3419L13.3161 14.6581M6.68387 8.65807L13.3161 5.34193M13.3161 5.34193C13.8087 6.32508 14.8255 7 16 7C17.6569 7 19 5.65685 19 4C19 2.34315 17.6569 1 16 1C14.3431 1 13 2.34315 13 4C13 4.48237 13.1138 4.93815 13.3161 5.34193ZM13.3161 14.6581C13.1138 15.0619 13 15.5176 13 16C13 17.6569 14.3431 19 16 19C17.6569 19 19 17.6569 19 16C19 14.3431 17.6569 13 16 13C14.8255 13 13.8087 13.6749 13.3161 14.6581Z"
                                                            strokeWidth="1.5"
                                                            stroke="black"
                                                            stroke-opacity="0.3"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                    </svg>
                                                </span>
                                            </div>
                                            <div className="flex items-center text-black-60 hover:text-orange-color cursor-pointer">
                                                <span>
                                                    <Badge
                                                        badgeContent={
                                                            currentRole ===
                                                                "host" ? (
                                                                <a
                                                                    className="dropdown-item text-bold"
                                                                    href="javascript:;"
                                                                    onClick={() =>
                                                                        isPIP
                                                                            ? history(
                                                                                "/page/livestream"
                                                                            )
                                                                            : console.log(
                                                                                "Clicked"
                                                                            )
                                                                    }
                                                                >
                                                                    {requestedList.length >
                                                                        0 && (
                                                                            <span
                                                                                class="badge badge-danger"
                                                                                style={{
                                                                                    top: -40,
                                                                                    left: 8,
                                                                                }}
                                                                            >
                                                                                {
                                                                                    requestedList.length
                                                                                }
                                                                            </span>
                                                                        )}
                                                                </a>
                                                            ) : (
                                                                <></>
                                                            )
                                                        }
                                                    >
                                                        <svg
                                                            onClick={() =>
                                                                setSelectedMenu(
                                                                    "Audience"
                                                                )
                                                            }
                                                            width="25"
                                                            height="22"
                                                            viewBox="0 0 25 22"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <path
                                                                d="M19.4986 18.06C20.9237 18.1765 22.3574 17.9929 23.7072 17.5211C23.7588 16.8859 23.6294 16.2491 23.3341 15.6844C23.0388 15.1197 22.5897 14.6501 22.0387 14.33C21.4876 14.0099 20.8572 13.8523 20.2204 13.8755C19.5835 13.8987 18.9663 14.1017 18.44 14.4611M19.4975 18.0589L19.4986 18.0938C19.4986 18.3469 19.4851 18.5966 19.457 18.843C17.4155 20.0143 15.1022 20.6288 12.7486 20.625C10.3074 20.625 8.01574 19.977 6.04024 18.843C6.01131 18.5826 5.99741 18.3208 5.99861 18.0589M19.4986 18.0589C19.4942 16.7838 19.1271 15.5364 18.44 14.4623M18.44 14.4623C17.8301 13.5058 16.9889 12.7185 15.994 12.1734C14.9992 11.6283 13.883 11.343 12.7486 11.3438C11.6144 11.3432 10.4984 11.6286 9.50381 12.1737C8.5092 12.7188 7.66811 13.5059 7.05836 14.4623M7.05836 14.4623C6.5321 14.1032 5.91496 13.9004 5.27829 13.8774C4.64163 13.8544 4.01145 14.012 3.46061 14.3321C2.90978 14.6521 2.46078 15.1216 2.16554 15.6861C1.8703 16.2507 1.74088 16.8872 1.79223 17.5223C3.14101 17.9967 4.57507 18.1795 5.99973 18.0589M7.05724 14.4623C6.37056 15.5365 6.00378 16.7839 5.99973 18.0589M16.1236 4.59375C16.1236 5.48886 15.768 6.3473 15.1351 6.98024C14.5022 7.61317 13.6437 7.96875 12.7486 7.96875C11.8535 7.96875 10.9951 7.61317 10.3621 6.98024C9.72919 6.3473 9.37361 5.48886 9.37361 4.59375C9.37361 3.69864 9.72919 2.8402 10.3621 2.20726C10.9951 1.57433 11.8535 1.21875 12.7486 1.21875C13.6437 1.21875 14.5022 1.57433 15.1351 2.20726C15.768 2.8402 16.1236 3.69864 16.1236 4.59375V4.59375ZM22.8736 7.96875C22.8736 8.30116 22.8081 8.63031 22.6809 8.93742C22.5537 9.24452 22.3673 9.52357 22.1322 9.75861C21.8972 9.99366 21.6181 10.1801 21.311 10.3073C21.0039 10.4345 20.6748 10.5 20.3424 10.5C20.01 10.5 19.6808 10.4345 19.3737 10.3073C19.0666 10.1801 18.7875 9.99366 18.5525 9.75861C18.3174 9.52357 18.131 9.24452 18.0038 8.93742C17.8766 8.63031 17.8111 8.30116 17.8111 7.96875C17.8111 7.29742 18.0778 6.65359 18.5525 6.17889C19.0272 5.70418 19.671 5.4375 20.3424 5.4375C21.0137 5.4375 21.6575 5.70418 22.1322 6.17889C22.6069 6.65359 22.8736 7.29742 22.8736 7.96875V7.96875ZM7.68611 7.96875C7.68611 8.30116 7.62064 8.63031 7.49343 8.93742C7.36622 9.24452 7.17977 9.52357 6.94472 9.75861C6.70968 9.99366 6.43063 10.1801 6.12353 10.3073C5.81642 10.4345 5.48727 10.5 5.15486 10.5C4.82245 10.5 4.4933 10.4345 4.18619 10.3073C3.87909 10.1801 3.60004 9.99366 3.365 9.75861C3.12995 9.52357 2.9435 9.24452 2.81629 8.93742C2.68908 8.63031 2.62361 8.30116 2.62361 7.96875C2.62361 7.29742 2.89029 6.65359 3.365 6.17889C3.8397 5.70418 4.48353 5.4375 5.15486 5.4375C5.82619 5.4375 6.47002 5.70418 6.94472 6.17889C7.41943 6.65359 7.68611 7.29742 7.68611 7.96875V7.96875Z"
                                                                stroke="black"
                                                                stroke-opacity="0.3"
                                                                stroke-width="1.6875"
                                                                stroke-linecap="round"
                                                                stroke-linejoin="round"
                                                            />
                                                        </svg>
                                                    </Badge>
                                                </span>
                                            </div>
                                        </Box>
                                    </div>
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                {isFullScreen || isPIP ? (
                    <></>
                ) : (
                    <Grid item xs={12} sm={12} lg={4} md={4}>
                        <Hidden only={["sm", "xs"]} implementation="css">
                            {!isPIP ? (
                                <>
                                    <div className="p-4 bg-white w-full">
                                        <div>
                                            <ul className="flex items-center space-x-5 pb-[7px] border-b border-black-10">
                                                <li>
                                                    <a
                                                        className={`text-md cursor font-medium text-black-60 hover:text-orange-color pb-[7px] hover:border-b-2 border-orange-color capitalize px-5 view-profile-nav whitespace-nowrap ${selectedMenu ==
                                                            "Chat"
                                                            ? "active"
                                                            : ""
                                                            }`}
                                                        onClick={() => {
                                                            setNewMessage(
                                                                false
                                                            );
                                                            setSelectedMenu(
                                                                "Chat"
                                                            );
                                                        }}
                                                    >
                                                        Chat
                                                    </a>
                                                </li>
                                                <li>
                                                    <a
                                                        className={`text-md cursor font-medium text-black-60 hover:text-orange-color pb-[7px] hover:border-b-2 border-orange-color capitalize px-5 view-profile-nav whitespace-nowrap ${selectedMenu ==
                                                            "Info"
                                                            ? "active"
                                                            : ""
                                                            }`}
                                                        onClick={() => {
                                                            setSelectedMenu(
                                                                "Info"
                                                            );
                                                        }}
                                                    >
                                                        Info
                                                    </a>
                                                </li>
                                                {cartProducts.length > 0 && (
                                                    <li>
                                                        <a
                                                            className={`text-md cursor font-medium text-black-60 hover:text-orange-color pb-[7px] hover:border-b-2 border-orange-color capitalize px-5 view-profile-nav whitespace-nowrap ${selectedMenu ==
                                                                "Product"
                                                                ? "active"
                                                                : ""
                                                                }`}
                                                            onClick={() =>
                                                                setSelectedMenu(
                                                                    "Product"
                                                                )
                                                            }
                                                        >
                                                            Product
                                                        </a>
                                                    </li>
                                                )}
                                                <li>
                                                    <a
                                                        className={`text-md cursor font-medium text-black-60 hover:text-orange-color pb-[7px] hover:border-b-2 border-orange-color capitalize px-5 view-profile-nav whitespace-nowrap ${selectedMenu ==
                                                            "Audience"
                                                            ? "active"
                                                            : ""
                                                            }`}
                                                        onClick={() =>
                                                            setSelectedMenu(
                                                                "Audience"
                                                            )
                                                        }
                                                    >
                                                        Audience
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>

                                        <div className="h-[calc(100vh_-_155px)] overflow-y-auto">
                                            <Grid container>
                                                <Grid item xs={12} md={12}>
                                                    <List dense disablePadding>
                                                        <ListItem
                                                            disableGutters
                                                        >
                                                            <ListItemAvatar>
                                                                <Avatar
                                                                    onClick={() =>
                                                                        dispatch(
                                                                            fetchOtherUserProfileRequest(
                                                                                livestream
                                                                                    .owner
                                                                                    ._id,
                                                                                history
                                                                            )
                                                                        )
                                                                    }
                                                                    src={getImage(
                                                                        livestream
                                                                            .owner
                                                                            .attachments
                                                                    )}
                                                                />
                                                            </ListItemAvatar>
                                                            <ListItemText
                                                                primary={
                                                                    livestream
                                                                        .owner
                                                                        .fullName
                                                                }
                                                                secondary={
                                                                    <Timer
                                                                        decrement={
                                                                            livestream
                                                                                .owner
                                                                                ._id ===
                                                                            userProfile._id
                                                                        }
                                                                        initialMinute={
                                                                            duration[1]
                                                                        }
                                                                        initialSeconds={
                                                                            duration[2]
                                                                        }
                                                                        initialHours={
                                                                            duration[0]
                                                                        }
                                                                        onClosing={(
                                                                            minutes,
                                                                            seconds
                                                                        ) => {
                                                                            if (
                                                                                minutes <
                                                                                6 &&
                                                                                IsNullOrEmpty(
                                                                                    closingMsg
                                                                                ) &&
                                                                                livestream
                                                                                    .owner
                                                                                    ._id ===
                                                                                userProfile._id
                                                                            ) {
                                                                                setClosingMsg(
                                                                                    `your live will automatically end in ${pad(
                                                                                        minutes,
                                                                                        2
                                                                                    )}: ${pad(
                                                                                        seconds,
                                                                                        2
                                                                                    )}`
                                                                                );
                                                                                Swal.fire(
                                                                                    {
                                                                                        title: "Reminder!",
                                                                                        iconHtml:
                                                                                            "<i class='fa fa-exclamation-triangle fa-danger fa-large'></i>",
                                                                                        customClass:
                                                                                        {
                                                                                            title: "text-danger",
                                                                                            icon: "border-none",
                                                                                            cancelButton:
                                                                                                "order-1 right-gap",
                                                                                            confirmButton:
                                                                                                "order-2",
                                                                                            denyButton:
                                                                                                "order-3",
                                                                                        },
                                                                                        html: `<p class="text-grey">Your live will be automatically ended in 5 minutes</p>`,
                                                                                        showCancelButton: true,
                                                                                        showConfirmButton: false,
                                                                                        cancelButtonText:
                                                                                            "Close",
                                                                                    }
                                                                                );
                                                                            }
                                                                        }}
                                                                    />
                                                                }
                                                            />
                                                        </ListItem>
                                                    </List>

                                                    {selectedMenu === "Chat" ? (
                                                        <div className="chat-container">
                                                            <div className="chat-area">
                                                                <List
                                                                    dense
                                                                    disablePadding
                                                                >
                                                                    {sortedComments.map(
                                                                        (x) => {
                                                                            return (
                                                                                <>
                                                                                    {x.commentType ===
                                                                                        "joined" ? (
                                                                                        <Alert
                                                                                            severity="info"
                                                                                            className="mb-1"
                                                                                        >
                                                                                            <strong>
                                                                                                {
                                                                                                    x.fullName
                                                                                                }
                                                                                            </strong>{" "}
                                                                                            has
                                                                                            joined
                                                                                        </Alert>
                                                                                    ) : x.commentType ===
                                                                                        "left" ||
                                                                                        x.commentType ===
                                                                                        "end" ? (
                                                                                        <Alert
                                                                                            severity="warning"
                                                                                            className="mb-1"
                                                                                        >
                                                                                            <strong>
                                                                                                {
                                                                                                    x.fullName
                                                                                                }
                                                                                            </strong>{" "}
                                                                                            has
                                                                                            left
                                                                                        </Alert>
                                                                                    ) : (
                                                                                        <ListItem
                                                                                            disableGutters
                                                                                        >
                                                                                            <ListItemAvatar>
                                                                                                <Avatar
                                                                                                    onClick={() =>
                                                                                                        dispatch(
                                                                                                            fetchOtherUserProfileRequest(
                                                                                                                x._id,
                                                                                                                history
                                                                                                            )
                                                                                                        )
                                                                                                    }
                                                                                                    src={
                                                                                                        x.image
                                                                                                    }
                                                                                                    alt="pp"
                                                                                                />
                                                                                            </ListItemAvatar>
                                                                                            <ListItemText
                                                                                                primary={
                                                                                                    x.fullName
                                                                                                }
                                                                                                secondary={
                                                                                                    x.message
                                                                                                }
                                                                                            />
                                                                                            <ListItemSecondaryAction>
                                                                                                {moment(
                                                                                                    x.dateCreated
                                                                                                ).fromNow()}
                                                                                                &nbsp;&nbsp;
                                                                                                {(x.pinned ==
                                                                                                    "yes" ||
                                                                                                    livestream
                                                                                                        .owner
                                                                                                        ._id ===
                                                                                                    userProfile._id) && (
                                                                                                        <i
                                                                                                            className="fa fa-thumb-tack"
                                                                                                            onClick={() => {
                                                                                                                if (
                                                                                                                    livestream
                                                                                                                        .owner
                                                                                                                        ._id ===
                                                                                                                    userProfile._id
                                                                                                                ) {
                                                                                                                    if (
                                                                                                                        x.isDB
                                                                                                                    ) {
                                                                                                                        SocialAPI.UpdatePinComment(
                                                                                                                            x.id,
                                                                                                                            x.pinned ==
                                                                                                                                "yes"
                                                                                                                                ? "no"
                                                                                                                                : "yes"
                                                                                                                        ).then(
                                                                                                                            (
                                                                                                                                cm
                                                                                                                            ) => {
                                                                                                                                dispatch(
                                                                                                                                    fetchEventRequest(
                                                                                                                                        "?where=livestream:" +
                                                                                                                                        livestream._id
                                                                                                                                    )
                                                                                                                                );
                                                                                                                            }
                                                                                                                        );
                                                                                                                    } else {
                                                                                                                        hmsActions.setMessageRead(
                                                                                                                            x.pinned ==
                                                                                                                                "no"
                                                                                                                                ? false
                                                                                                                                : true,
                                                                                                                            x.id
                                                                                                                        );
                                                                                                                    }
                                                                                                                }
                                                                                                            }}
                                                                                                            style={{
                                                                                                                opacity:
                                                                                                                    x.pinned ==
                                                                                                                        "yes"
                                                                                                                        ? 1
                                                                                                                        : 0.4,
                                                                                                                color: "red",
                                                                                                                transform:
                                                                                                                    "rotate(30deg)",
                                                                                                            }}
                                                                                                        ></i>
                                                                                                    )}
                                                                                            </ListItemSecondaryAction>
                                                                                        </ListItem>
                                                                                    )}
                                                                                </>
                                                                            );
                                                                        }
                                                                    )}
                                                                </List>
                                                            </div>
                                                            {comments &&
                                                                comments.filter(
                                                                    (x) =>
                                                                        x.commentType ===
                                                                        "end"
                                                                ).length === 0 ? (
                                                                <TextField
                                                                    fullWidth
                                                                    placeholder="Type message"
                                                                    variant="outlined"
                                                                    onKeyPress={(
                                                                        e
                                                                    ) => {
                                                                        if (
                                                                            e.key ==
                                                                            "Enter"
                                                                        ) {
                                                                            sendComment();
                                                                        }
                                                                    }}
                                                                    inputProps={{
                                                                        id: "sendComment",
                                                                    }}
                                                                    InputProps={{
                                                                        endAdornment:
                                                                            (
                                                                                <InputAdornment position="end">
                                                                                    <svg
                                                                                        onClick={() =>
                                                                                            sendComment()
                                                                                        }
                                                                                        width="15"
                                                                                        height="16"
                                                                                        viewBox="0 0 15 16"
                                                                                        fill="none"
                                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                                    >
                                                                                        <path
                                                                                            d="M2.25 8L0.749999 14.75L14.25 8L0.75 1.25L2.25 8ZM2.25 8L8.25 8"
                                                                                            stroke="#7900F8"
                                                                                            stroke-width="1.5"
                                                                                            stroke-linecap="round"
                                                                                            stroke-linejoin="round"
                                                                                        />
                                                                                    </svg>
                                                                                </InputAdornment>
                                                                            ),
                                                                    }}
                                                                />
                                                            ) : (
                                                                <span />
                                                            )}
                                                        </div>
                                                    ) : selectedMenu ===
                                                        "Info" ? (
                                                        <>
                                                            <div className="mt-4">
                                                                <h4 className="text-sm font-medium text-black mb-0.5">
                                                                    {
                                                                        livestream.title
                                                                    }
                                                                </h4>
                                                                <p className="text-sm font-normal text-black-50">
                                                                    {
                                                                        livestream.contents
                                                                    }
                                                                </p>
                                                            </div>

                                                            <br />
                                                            {livestream.hashtags.map(
                                                                (x, index) => {
                                                                    let cb =
                                                                        tagColors.length >
                                                                            index
                                                                            ? tagColors[
                                                                            index
                                                                            ]
                                                                            : tagColors[0];
                                                                    return (
                                                                        <button
                                                                            className={
                                                                                "btn btn-sm btn-hash ml-2 " +
                                                                                cb
                                                                            }
                                                                        >
                                                                            #
                                                                            {x ||
                                                                                x.id}
                                                                            &nbsp;&nbsp;
                                                                        </button>
                                                                    );
                                                                }
                                                            )}

                                                            {livestream.attachments &&
                                                                selectedCategory.name !==
                                                                "VIP Circle" ? (
                                                                <div className="form-group">
                                                                    <label className="text-bold my-2">
                                                                        Thumbnail
                                                                    </label>
                                                                    <Box
                                                                        display="flex"
                                                                        alignItems="center"
                                                                        justifyContent="center"
                                                                    >
                                                                        <img
                                                                            style={{
                                                                                maxWidth: 192,
                                                                            }}
                                                                            src={getImage(
                                                                                livestream.attachments
                                                                            )}
                                                                            alt="user profile image"
                                                                        />
                                                                    </Box>
                                                                </div>
                                                            ) : (
                                                                <span />
                                                            )}
                                                        </>
                                                    ) : selectedMenu ===
                                                        "Product" ? (
                                                        <div className="">
                                                            {cartProducts &&
                                                                cartProducts.map(
                                                                    (
                                                                        product
                                                                    ) => {
                                                                        return (
                                                                            <div
                                                                                key={
                                                                                    product._id
                                                                                }
                                                                                className="mb-5"
                                                                            >
                                                                                <div className="px-3.5 py-5 border border-black-10 rounded-md bg-white">
                                                                                    <div className="grid grid-cols-2 gap-x-[18px]">
                                                                                        <div className="">
                                                                                            <ReactImageGallery
                                                                                                showNav={
                                                                                                    false
                                                                                                }
                                                                                                showPlayButton={
                                                                                                    false
                                                                                                }
                                                                                                items={
                                                                                                    product
                                                                                                        .allAttachments
                                                                                                        .length >
                                                                                                        0
                                                                                                        ? product.allAttachments
                                                                                                            .concat(
                                                                                                                product.attachments
                                                                                                            )
                                                                                                            .map(
                                                                                                                (
                                                                                                                    x
                                                                                                                ) => {
                                                                                                                    return {
                                                                                                                        thumbnailWidth: 32,
                                                                                                                        thumbnailHeight: 32,
                                                                                                                        id: x._id,
                                                                                                                        original:
                                                                                                                            getImage(
                                                                                                                                x
                                                                                                                            ),
                                                                                                                        thumbnail:
                                                                                                                            getImage(
                                                                                                                                x
                                                                                                                            ),
                                                                                                                    };
                                                                                                                }
                                                                                                            )
                                                                                                        : [
                                                                                                            {
                                                                                                                thumbnailWidth: 32,
                                                                                                                thumbnailHeight: 32,
                                                                                                                id: product
                                                                                                                    .attachments
                                                                                                                    ._id,
                                                                                                                original:
                                                                                                                    getImage(
                                                                                                                        product.attachments
                                                                                                                    ),
                                                                                                                thumbnail:
                                                                                                                    getImage(
                                                                                                                        product.attachments
                                                                                                                    ),
                                                                                                            },
                                                                                                        ]
                                                                                                }
                                                                                            />
                                                                                        </div>
                                                                                        <div className="">
                                                                                            <h5 className="text-extraSmall text-black-50">
                                                                                                {
                                                                                                    product.name
                                                                                                }
                                                                                            </h5>
                                                                                            <p className="text-sm font-medium text-orange-color uppercase mb-1.5">
                                                                                                {
                                                                                                    product.currency
                                                                                                }{" "}
                                                                                                {product.price.toFixed(
                                                                                                    2
                                                                                                )}
                                                                                            </p>

                                                                                            <p className="text-extraSmall font-medium text-black capitalize mb-[1px]">
                                                                                                Stock
                                                                                                Quantity:{" "}
                                                                                                {
                                                                                                    product
                                                                                                        .warehouse
                                                                                                        .quantity
                                                                                                }
                                                                                            </p>
                                                                                            <Tooltip
                                                                                                title={product.descriptions}
                                                                                            >
                                                                                                <p className="text-sm font-normal text-black-50">
                                                                                                    {
                                                                                                        product.descriptions.length > 100
                                                                                                            ? product.descriptions.slice(0, 100) +
                                                                                                            "..."
                                                                                                            : product.descriptions
                                                                                                    }
                                                                                                </p>
                                                                                            </Tooltip>
                                                                                        </div>
                                                                                    </div>
                                                                                    {livestream
                                                                                        .owner
                                                                                        ._id !==
                                                                                        userProfile._id ? (
                                                                                        <div className=" flex items-center gap-5 mt-5">
                                                                                            <button
                                                                                                onClick={() => {
                                                                                                    dispatch(
                                                                                                        addCartRequest(
                                                                                                            {
                                                                                                                product:
                                                                                                                    product._id,
                                                                                                                quantity: 1,
                                                                                                                livestream:
                                                                                                                    livestream._id,
                                                                                                            }
                                                                                                        )
                                                                                                    );
                                                                                                }}
                                                                                                className="py-[7px] w-full block capitalize rounded-lg text-sm font-medium bg-white border border-black-10 text-black-50 whitespace-nowrap"
                                                                                            >
                                                                                                Add
                                                                                                to
                                                                                                Cart
                                                                                            </button>
                                                                                            <button
                                                                                                onClick={() => {
                                                                                                    dispatch(
                                                                                                        addCartRequest(
                                                                                                            {
                                                                                                                product:
                                                                                                                    product._id,
                                                                                                                quantity: 1,
                                                                                                                livestream:
                                                                                                                    livestream._id,
                                                                                                                history:
                                                                                                                    history,
                                                                                                                canNavigate: true,
                                                                                                            }
                                                                                                        )
                                                                                                    );
                                                                                                }}
                                                                                                className="py-[7px] w-full block capitalize rounded-lg text-sm font-bold bg-orange-color text-white whitespace-nowrap"
                                                                                            >
                                                                                                Buy
                                                                                                it
                                                                                                Now
                                                                                            </button>
                                                                                        </div>
                                                                                    ) : (
                                                                                        <>

                                                                                        </>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        );
                                                                    }
                                                                )}
                                                        </div>
                                                    ) : selectedMenu ===
                                                        "Audience" ? (
                                                        <div
                                                            className="inner-glow"
                                                            style={{
                                                                maxHeight:
                                                                    "calc(100vh - 230px)",
                                                                overflowY:
                                                                    "auto",
                                                                minHeight:
                                                                    "calc(100vh - 230px)",
                                                            }}
                                                        >
                                                            <p className="text-center mb-4">
                                                                <span className="text-bold">
                                                                    {peers && peers.filter(s => s.name !== "Beam").length}
                                                                </span>{" "}
                                                                joined this live
                                                            </p>
                                                            {
                                                                peers && peers.filter(s => s.name !== "Beam").map((x) => {
                                                                    let metadata =
                                                                        {};
                                                                    if (
                                                                        !IsNullOrEmpty(
                                                                            x.metadata
                                                                        )
                                                                    ) {
                                                                        metadata =
                                                                            JSON.parse(
                                                                                x.metadata
                                                                            );
                                                                    }

                                                                    return (
                                                                        <>
                                                                            <div className="py-[3px] pl-1.5 pr-4 flex items-center justify-between rounded-md border border-black-10 mb-2.5 cursor-pointer">
                                                                                <div className="flex items-center">
                                                                                    <img
                                                                                        onClick={() => {
                                                                                            if (
                                                                                                userProfile._id ===
                                                                                                x.customerUserId
                                                                                            ) {
                                                                                                dispatch(
                                                                                                    fetchUserProfileRequest(
                                                                                                        x.customerUserId
                                                                                                    )
                                                                                                );
                                                                                                history(
                                                                                                    "/" +
                                                                                                    userProfile
                                                                                                        .account
                                                                                                        .userName
                                                                                                );
                                                                                            } else {
                                                                                                dispatch(
                                                                                                    fetchOtherUserProfileRequest(
                                                                                                        x.customerUserId,
                                                                                                        history
                                                                                                    )
                                                                                                );
                                                                                            }
                                                                                        }}
                                                                                        src={
                                                                                            metadata.image
                                                                                                ? metadata.image
                                                                                                : ProfilePic
                                                                                        }
                                                                                        alt=""
                                                                                        className="rounded-full w-[35px] aspect-square mr-2.5"
                                                                                    />
                                                                                    <h4 className="text-md font-medium text-ebony-color capitalize">
                                                                                        {
                                                                                            x.name
                                                                                        }
                                                                                    </h4>
                                                                                </div>
                                                                                <span className="float-right">
                                                                                    {livestream
                                                                                        .owner
                                                                                        ._id ===
                                                                                        userProfile._id &&
                                                                                        x.roleName ===
                                                                                        "guest" ? (
                                                                                        <button
                                                                                            className="py-1 px-2 bg-red-500 text-white text-sm capitalize rounded-lg whitespace-nowrap w-full sm:w-fit"
                                                                                            onClick={() =>
                                                                                                handleRemoveUser(
                                                                                                    x
                                                                                                )
                                                                                            }
                                                                                        >
                                                                                            Remove
                                                                                            as
                                                                                            co-host
                                                                                        </button>
                                                                                    ) : (
                                                                                        <>

                                                                                        </>
                                                                                    )}
                                                                                    {livestream
                                                                                        .owner
                                                                                        ._id ===
                                                                                        userProfile._id &&
                                                                                        x.roleName ===
                                                                                        "audience" &&
                                                                                        metadata.isRequested ? (
                                                                                        <button
                                                                                            className="py-1 px-2 bg-orange-color text-white text-sm capitalize rounded-lg whitespace-nowrap w-full sm:w-fit"
                                                                                            onClick={() =>
                                                                                                handleAddUser(
                                                                                                    x
                                                                                                )
                                                                                            }
                                                                                        >
                                                                                            Accept
                                                                                            as
                                                                                            co-host
                                                                                        </button>
                                                                                    ) : (
                                                                                        <>

                                                                                        </>
                                                                                    )}
                                                                                </span>
                                                                            </div>
                                                                        </>
                                                                    );
                                                                })
                                                            }
                                                        </div>
                                                    ) : (
                                                        <span />
                                                    )}
                                                </Grid>
                                            </Grid>
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <></>
                            )}
                        </Hidden>

                        <Modal
                            show={showShared}
                            onClose={() => setShared(false)}
                        >
                            <SharePop
                                onClose={() => setShared(false)}
                                shareUrl={shareUrl}
                                title={livestream.owner.fullName}
                                subTitle={"@" + livestream.owner.userName}
                                image={getImage(livestream.owner.attachments)}
                                heading="Share"
                            />
                        </Modal>
                    </Grid>
                )}
            </Grid>
        </div>
    );
}
